export const translations = {
  en: {
    // Navigation
    nav: {
      group: 'SRE GLOBAL',
      riskKnowledge: 'Risk Knowledge',
      sustainability: 'Sustainability',
      aboutUs: 'About us',
      ourBusiness: 'Our business',
      investors: 'Investors',
      media: 'Media',
      careers: 'Careers',
      regionalSites: 'Regional sites',
      trading: 'Trading Platform',
      insurance: 'Insurance',
      tourism: 'Tourism',
      clientTools: 'Client Tools',
      mutualFunds: 'Mutual Funds',
      contact: 'Contact',
      forms: 'Forms'
    },
    // Hero Section
    hero: {
      title1: 'Leading Global Financial Services',
      desc1: 'Comprehensive trading platform solutions for modern investors',
      title2: 'Insurance & Protection',
      desc2: 'Safeguarding your future with comprehensive insurance solutions',
      title3: 'Travel & Tourism Excellence',
      desc3: 'Discover the world with our premium tourism services',
      readMore: 'Read more'
    },
    // Home Sections
    home: {
      clientTools: 'Client tools and services',
      clientToolsDesc: 'Discover our client tools and services, including information on our many digital tools as well as training courses on a wide range of topics in the financial and insurance industry.',
      exploreTools: 'Explore client tools and services',
      ourGroup: 'OUR GROUP',
      groupDesc: 'SRE GLOBAL is one of the world\'s leading providers of trading platforms, insurance, and tourism services, working to make the world more resilient. The aim of SRE GLOBAL is to enable society to thrive and progress, creating new opportunities and solutions for our clients.',
      ourBusiness: 'Our businesses',
      disclaimer: 'Important Notice',
      disclaimerText: 'SRE GLOBAL is an independent company and is not affiliated with, connected to, or associated with any company of similar name based in South Korea or elsewhere. We operate independently with our own management, services, and operations.',
      licensesTitle: 'SRE GLOBAL Yetkili Aracı Kurum & FCA Regulation',
      licensesSubtitle: 'SRE GLOBAL is a fully authorized brokerage firm regulated by leading financial authorities, ensuring the highest standards of security and compliance for our clients.',
      spkTitle: 'Yetkili Aracı Kurum',
      spkDesc: 'SRE GLOBAL is an authorized brokerage firm (Yetkili Aracı Kurum) ensuring full compliance with financial regulations and providing comprehensive client protection.',
      spkType: 'Authorization Type: Authorized Brokerage Firm',
      fcaTitle: 'UK FCA License',
      fcaDesc: 'Authorized and regulated by the UK Financial Conduct Authority. Our FCA license demonstrates our commitment to maintaining the highest standards of financial services and regulatory compliance.',
      fcaType: 'License Type: Financial Conduct Authority Authorization'
    },
    // Business Sections
    business: {
      trading: {
        title: 'Trading Platform',
        desc: 'We provide you with a comprehensive trading platform with premium products and tailored solutions for modern investors.',
        discover: 'Discover Trading Platform'
      },
      insurance: {
        title: 'Insurance Services',
        desc: 'We help protect your assets, family, and future with comprehensive insurance coverage and risk management solutions.',
        discover: 'Discover Insurance'
      },
      investment: {
        title: 'Mutual Funds',
        desc: 'Access over 18,000 funds from world\'s top money managers. Expert management, built-in diversification, and professional portfolio solutions.',
        discover: 'Discover Mutual Funds'
      },
      tourism: {
        title: 'Tourism Services',
        desc: 'Experience world-class travel and tourism services designed to create unforgettable journeys and memories.',
        discover: 'Discover Tourism'
      }
    },
    // Footer
    footer: {
      newsletter: 'Newsletter',
      subscribe: 'Subscribe',
      contact: 'Contact us',
      contactBtn: 'Contact',
      copyright: '© 2026 SRE GLOBAL. All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      cookiePolicy: 'Cookie Policy',
      regulatedTitle: 'Regulated & Authorized',
      spkLicense: 'Yetkili Aracı Kurum:',
      spkLicenseText: 'SRE GLOBAL is an authorized brokerage firm (Yetkili Aracı Kurum), ensuring compliance with financial regulations.',
      fcaLicense: 'UK FCA License:',
      fcaLicenseText: 'SRE GLOBAL is authorized and regulated by the Financial Conduct Authority (FCA) in the United Kingdom.',
      licenseNote: 'These licenses demonstrate our commitment to regulatory compliance, client protection, and maintaining the highest standards in financial services.',
      newsletterPopupTitle: 'Subscribe to Our Newsletter',
      newsletterPopupDesc: 'Get the latest updates on trading platforms, investment opportunities, and market insights from SRE GLOBAL.',
      newsletterEmailLabel: 'Email Address',
      newsletterEmailPlaceholder: 'your@email.com',
      newsletterSubscribeBtn: 'Subscribe Now',
      newsletterSuccessTitle: 'Subscribed!',
      newsletterSuccessDesc: 'Thank you for subscribing to our newsletter.',
      newsletterDisclaimer: 'By subscribing, you agree to our Privacy Policy. You can unsubscribe at any time.'
    },
    // Trading Platform Page
    trading: {
      heroTitle: 'SRE GLOBAL TRADING PLATFORM',
      heroDesc: 'White Label Trading Solutions & Full-Package Brokerage Systems. Partner with SRE GLOBAL, an authorized brokerage firm (Yetkili Aracı Kurum), to launch your own trading platform with our proven technology.',
      becomePartner: 'Become a Partner',
      introTitle: 'White Label Trading Technology Provider',
      introDesc1: 'SRE GLOBAL TRADING PLATFORM, an authorized brokerage firm (Yetkili Aracı Kurum), is a leading provider of white label trading solutions and turnkey brokerage systems. Similar to industry leaders like Leverate and MetaQuotes, we provide the technology infrastructure that enables brokers and financial institutions to launch and operate their own trading platforms.',
      introDesc2: 'We don\'t trade with end investors directly. Instead, we empower our partners with cutting-edge technology, comprehensive CRM systems, risk management tools, and full back-office solutions to run successful brokerage operations.',
      solutionsTitle: 'Our Solutions',
      whiteLabelTitle: 'White Label Platform',
      whiteLabelDesc: 'Launch your branded trading platform with our fully customizable white label solution. Complete control over branding, features, and user experience.',
      fullPackageTitle: 'Full Package with CRM',
      fullPackageDesc: 'Complete brokerage solution including advanced CRM, client onboarding, KYC/AML compliance, payment processing, and reporting tools.',
      riskManagementTitle: 'Risk Management Suite',
      riskManagementDesc: 'Advanced risk management tools to protect your brokerage, monitor exposure, and ensure sustainable operations with real-time analytics.',
      platformsTitle: 'Trading Platforms',
      platformsDesc: 'Integration with MetaTrader 4, MetaTrader 5, and custom web-based trading platforms. Multi-device support across desktop, mobile, and tablets.',
      liquidityTitle: 'Liquidity Solutions',
      liquidityDesc: 'Access to deep liquidity pools, competitive pricing, and direct market access through our network of tier-1 liquidity providers.',
      techSupportTitle: '24/7 Technical Support',
      techSupportDesc: 'Round-the-clock technical support and maintenance to ensure your platform runs smoothly with maximum uptime.',
      whyChooseTitle: 'Why Choose SRE GLOBAL?',
      licensedTitle: 'Licensed & Regulated',
      licensedDesc: 'Fully authorized brokerage firm (Yetkili Aracı Kurum) and UK FCA regulated, ensuring compliance and trust.',
      provenTitle: 'Proven Technology',
      provenDesc: 'Battle-tested infrastructure serving thousands of traders with institutional-grade reliability.',
      customizableTitle: 'Fully Customizable',
      customizableDesc: 'Tailor every aspect of the platform to match your brand and business requirements.',
      scalableTitle: 'Scalable Infrastructure',
      scalableDesc: 'Built to grow with your business, from startup to enterprise-level operations.',
      ctaTitle: 'Ready to Launch Your Trading Platform?',
      ctaDesc: 'Partner with SRE GLOBAL to leverage our licensed technology and start your brokerage business today.',
      requestDemo: 'Request a Demo'
    },
    // Insurance Page
    insurance: {
      heroTitle: 'SRE GLOBAL insurance',
      heroDesc: 'Comprehensive insurance solutions designed to protect you, your loved ones, and your assets. With SRE GLOBAL insurance, you\'re covered for life\'s uncertainties.',
      getQuote: 'Get Your Free Quote',
      introTitle: 'Your Trusted Insurance Partner',
      introDesc: 'SRE GLOBAL insurance stands as a pillar of security and trust in the insurance industry. With decades of experience and a commitment to excellence, we provide comprehensive insurance solutions that safeguard what matters most to you. From individual policies to corporate coverage, our insurance services are designed to give you peace of mind in an uncertain world.',
      servicesTitle: 'Our Insurance Services',
      lifeTitle: 'Life Insurance',
      lifeDesc: 'Protect your family\'s financial future with comprehensive life insurance coverage tailored to your needs.',
      healthTitle: 'Health Insurance',
      healthDesc: 'Access quality healthcare with our flexible health insurance plans covering medical expenses and treatments.',
      propertyTitle: 'Property Insurance',
      propertyDesc: 'Safeguard your home and valuable possessions against damage, theft, and natural disasters.',
      businessTitle: 'Business Insurance',
      businessDesc: 'Comprehensive coverage for businesses including liability, property, and workers compensation.',
      travelTitle: 'Travel Insurance',
      travelDesc: 'Travel with confidence knowing you\'re protected against trip cancellations, medical emergencies, and lost luggage.',
      autoTitle: 'Auto Insurance',
      autoDesc: 'Complete vehicle protection with coverage for accidents, theft, and third-party liabilities.',
      whyChooseTitle: 'Why Choose SRE GLOBAL Insurance?',
      comprehensiveTitle: 'Comprehensive Coverage',
      comprehensiveDesc: 'Extensive insurance solutions covering every aspect of personal and business protection.',
      trustedTitle: 'Trusted Expertise',
      trustedDesc: 'Decades of experience and thousands of satisfied clients worldwide.',
      claimsTitle: 'Fast Claims Processing',
      claimsDesc: 'Quick and efficient claims handling to get you back on track faster.',
      customTitle: 'Customizable Plans',
      customDesc: 'Flexible insurance plans tailored to your specific needs and budget.',
      getStartedTitle: 'Get Started Today',
      getStartedDesc: 'Protect what matters most. Get a free quote and discover the right insurance coverage for you.',
      contactUs: 'Contact Us'
    },
    // Tourism Page
    tourism: {
      heroTitle: 'SRE GLOBAL Tourism',
      heroDesc: 'Discover the world with SRE GLOBAL Tourism. From exotic destinations to cultural experiences, we create unforgettable journeys tailored to your dreams.',
      exploreDest: 'Explore Destinations',
      introTitle: 'Your Gateway to the World',
      introDesc: 'SRE GLOBAL Tourism offers premium travel and tourism services designed to create unforgettable experiences. Whether you\'re planning a family vacation, romantic getaway, business trip, or adventure of a lifetime, our expert team crafts personalized itineraries that exceed expectations.',
      servicesTitle: 'Our Tourism Services',
      packageTitle: 'Holiday Packages',
      packageDesc: 'Curated vacation packages to the world\'s most beautiful destinations with accommodation, flights, and tours included.',
      culturalTitle: 'Cultural Tours',
      culturalDesc: 'Immersive cultural experiences exploring history, art, cuisine, and local traditions around the globe.',
      adventureTitle: 'Adventure Travel',
      adventureDesc: 'Thrilling adventures including safaris, trekking, diving, and extreme sports for adrenaline seekers.',
      luxuryTitle: 'Luxury Travel',
      luxuryDesc: 'Exclusive luxury experiences with 5-star accommodations, private tours, and personalized concierge services.',
      businessTitle: 'Business Travel',
      businessDesc: 'Efficient corporate travel management including flights, hotels, meetings, and event organization.',
      cruiseTitle: 'Cruise Vacations',
      cruiseDesc: 'Unforgettable cruise experiences exploring multiple destinations in comfort and style.',
      whyChooseTitle: 'Why Travel with SRE GLOBAL?',
      expertTitle: 'Expert Planning',
      expertDesc: 'Experienced travel consultants crafting perfect itineraries tailored to your preferences.',
      dealsTitle: 'Best Deals',
      dealsDesc: 'Competitive prices and exclusive deals with trusted partners worldwide.',
      supportTitle: '24/7 Support',
      supportDesc: 'Round-the-clock assistance during your travels for peace of mind.',
      personalizedTitle: 'Personalized Service',
      personalizedDesc: 'Every journey is customized to match your interests, budget, and travel style.',
      startTitle: 'Start Your Journey Today',
      startDesc: 'Ready to explore the world? Let us plan your next unforgettable adventure.',
      planTrip: 'Plan Your Trip'
    },
    // Contact Page
    contact: {
      heroTitle: 'Contact Us',
      heroDesc: 'We\'re here to help. Reach out to us anytime.',
      getInTouch: 'Get in Touch',
      getInTouchDesc: 'Have questions about our services? Want to become a partner? Need support? Our team is ready to assist you.',
      officeTitle: 'Our Offices',
      officeAddress: 'SRE GLOBAL, Mythenquai, Zurich, Switzerland',
      emailTitle: 'Email Us',
      emailDesc: 'For general inquiries and support',
      businessTitle: 'Business Inquiries',
      businessDesc: 'For partnership and business opportunities',
      formTitle: 'Send us a Message',
      nameLabel: 'Full Name',
      namePlaceholder: 'John Doe',
      emailLabel: 'Email Address',
      emailPlaceholder: 'john@example.com',
      subjectLabel: 'Subject',
      subjectPlaceholder: 'How can we help?',
      messageLabel: 'Message',
      messagePlaceholder: 'Tell us more about your inquiry...',
      sendMessage: 'Send Message',
      successTitle: 'Message Sent!',
      successDesc: 'Thank you for contacting us. We\'ll get back to you within 24 hours.'
    },
    // About Page
    about: {
      heroTitle: 'About SRE GLOBAL',
      heroDesc: 'A Switzerland-based financial services company committed to delivering innovative, secure, and client-focused investment solutions on a global scale.',
      aboutTitle: 'About Us',
      aboutPara1: 'SRE GLOBAL is a Switzerland-based financial services company committed to delivering innovative, secure, and client-focused investment solutions on a global scale. Operating at the intersection of international capital markets and advanced financial technologies, we provide tailored services designed to meet the evolving needs of both individual and institutional investors.',
      aboutPara2: 'As a company backed by the strength and heritage of its parent group, SWISS RE, SRE GLOBAL benefits from a solid foundation of financial expertise, risk management excellence, and global market insight. This strategic positioning enables us to offer high-quality services built on trust, transparency, and long-term value creation.',
      aboutPara3: 'Our operations are aligned with internationally recognized regulatory standards. Through our group structure, we maintain compliance with key financial authorities, including the UK Financial Conduct Authority (FCA). As an authorized brokerage firm (Yetkili Aracı Kurum), this multi-jurisdictional regulatory framework ensures that our clients receive services that adhere to the highest levels of governance, security, and operational integrity.',
      aboutPara4: 'At SRE GLOBAL, we specialize in a wide range of financial services including portfolio management, investment advisory, capital markets solutions, and risk management strategies. Our mission is to empower our clients with the tools, insights, and opportunities they need to achieve sustainable financial success in an increasingly complex global market.',
      aboutPara5: 'Driven by innovation and guided by expertise, SRE GLOBAL continues to build strong partnerships and deliver excellence across every aspect of financial services.',
      ourStoryTitle: 'Our Story',
      ourStoryDesc: 'Founded with a vision to revolutionize financial services, SRE GLOBAL has grown into a trusted global brand serving thousands of clients worldwide. Our journey is built on innovation, integrity, and an unwavering commitment to excellence.',
      missionTitle: 'Our Mission',
      missionDesc: 'To empower our clients with the tools, insights, and opportunities they need to achieve sustainable financial success in an increasingly complex global market.',
      visionTitle: 'Our Vision',
      visionDesc: 'To become the most trusted and innovative provider of integrated financial, insurance, and tourism services globally.',
      valuesTitle: 'Our Values',
      integrityTitle: 'Integrity',
      integrityDesc: 'We operate with honesty, transparency, and ethical practices in everything we do.',
      excellenceTitle: 'Excellence',
      excellenceDesc: 'We strive for excellence in service delivery and continuously improve our offerings.',
      innovationTitle: 'Innovation',
      innovationDesc: 'We embrace technology and innovation to provide cutting-edge solutions.',
      trustTitle: 'Trust',
      trustDesc: 'We build lasting relationships based on trust, reliability, and client satisfaction.',
      globalTitle: 'Global Presence',
      globalDesc: 'With offices and partners around the world, SRE GLOBAL serves clients across continents, delivering localized expertise with global standards.'
    },
    // Client Tools Page
    clientTools: {
      heroTitle: 'Client Tools & Services',
      heroDesc: 'Access our comprehensive suite of digital tools, training resources, and services designed to empower your success.',
      toolsTitle: 'Digital Tools',
      toolsDesc: 'Explore our cutting-edge digital tools designed to enhance your trading, investment, and service experience.',
      platformTitle: 'Trading Platform Access',
      platformDesc: 'Access our advanced trading platforms with real-time data, charting tools, and seamless execution.',
      analyticsTitle: 'Market Analytics',
      analyticsDesc: 'In-depth market analysis, research reports, and insights to inform your investment decisions.',
      portfolioTitle: 'Portfolio Manager',
      portfolioDesc: 'Track and manage your investments with our intuitive portfolio management tools.',
      trainingTitle: 'Training & Education',
      trainingDesc: 'Enhance your knowledge with our comprehensive training programs and educational resources.',
      webinarsTitle: 'Live Webinars',
      webinarsDesc: 'Join live webinars hosted by industry experts covering trading strategies, market trends, and more.',
      coursesTitle: 'Online Courses',
      coursesDesc: 'Self-paced courses covering everything from beginner fundamentals to advanced trading techniques.',
      supportTitle: 'Support Services',
      accountTitle: 'Account Management',
      accountDesc: 'Dedicated account managers to assist with your needs and optimize your experience.',
      techTitle: 'Technical Support',
      techDesc: '24/7 technical support to ensure smooth operations and quick issue resolution.',
      accessTitle: 'Access Your Tools',
      accessDesc: 'Log in to your client portal to access all available tools and resources.',
      login: 'Client Login'
    },
    // Forms Page
    forms: {
      heroTitle: 'Request Information',
      heroDesc: 'Fill out the form below and our team will get back to you shortly.',
      partnerTitle: 'Become a Partner',
      partnerDesc: 'Interested in partnering with SRE GLOBAL? Fill out this form to start the conversation.',
      demoTitle: 'Request a Demo',
      demoDesc: 'See our trading platform in action. Request a personalized demo from our team.',
      quoteTitle: 'Get an Insurance Quote',
      quoteDesc: 'Get a free, no-obligation insurance quote tailored to your needs.',
      tripTitle: 'Plan a Trip',
      tripDesc: 'Tell us about your dream destination and let us create the perfect itinerary.',
      generalTitle: 'General Inquiry',
      generalDesc: 'Have a question or need information? Send us a message.',
      nameLabel: 'Full Name',
      namePlaceholder: 'Your Name',
      emailLabel: 'Email',
      emailPlaceholder: 'your@email.com',
      phoneLabel: 'Phone (optional)',
      phonePlaceholder: '+1234567890',
      companyLabel: 'Company Name',
      companyPlaceholder: 'Your Company',
      serviceLabel: 'Service Interest',
      messageLabel: 'Message',
      messagePlaceholder: 'Tell us more...',
      submit: 'Submit Request',
      successTitle: 'Request Submitted!',
      successDesc: 'Thank you! We\'ll contact you within 24 hours.'
    },
    // Mutual Funds Page
    mutualFunds: {
      heroTitle: 'Mutual Funds',
      heroDesc: 'Access over 18,000 funds from the world\'s top money managers. Expert management, built-in diversification, and professional portfolio solutions.',
      accessFunds: 'Access Funds',
      introTitle: 'Professional Fund Management',
      introDesc: 'SRE GLOBAL provides access to an extensive selection of mutual funds from leading asset managers worldwide. Whether you\'re a conservative investor seeking steady growth or an aggressive investor looking for higher returns, we offer funds to match every investment objective and risk profile.',
      whyTitle: 'Why Invest in Mutual Funds?',
      diversificationTitle: 'Diversification',
      diversificationDesc: 'Spread your investments across multiple securities to reduce risk.',
      managementTitle: 'Professional Management',
      managementDesc: 'Experienced fund managers make investment decisions on your behalf.',
      accessibilityTitle: 'Accessibility',
      accessibilityDesc: 'Start investing with relatively small amounts compared to direct stock purchases.',
      liquidityTitle: 'Liquidity',
      liquidityDesc: 'Buy and sell fund shares easily, providing flexibility for your portfolio.',
      categoriesTitle: 'Fund Categories',
      equityTitle: 'Equity Funds',
      equityDesc: 'Invest in stocks for long-term capital appreciation and growth potential.',
      bondTitle: 'Bond Funds',
      bondDesc: 'Fixed-income investments providing regular interest income with lower risk.',
      balancedTitle: 'Balanced Funds',
      balancedDesc: 'Mix of stocks and bonds offering balanced growth and income.',
      indexTitle: 'Index Funds',
      indexDesc: 'Track market indices with low fees and broad market exposure.',
      getStartedTitle: 'Start Investing Today',
      getStartedDesc: 'Explore our fund selection and begin building your investment portfolio.',
      exploreFunds: 'Explore Funds'
    },
    // Legal Pages
    legal: {
      privacyTitle: 'Privacy Policy',
      privacyEffective: 'Effective Date: January 1, 2026',
      privacyIntro: 'SRE GLOBAL ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.',
      termsTitle: 'Terms & Conditions',
      termsEffective: 'Effective Date: January 1, 2026',
      termsIntro: 'These Terms and Conditions ("Terms") govern your use of the SRE GLOBAL website and services. By accessing or using our services, you agree to be bound by these Terms.',
      cookieTitle: 'Cookie Policy',
      cookieEffective: 'Effective Date: January 1, 2026',
      cookieIntro: 'This Cookie Policy explains how SRE GLOBAL uses cookies and similar technologies to recognize you when you visit our website.',
      section1Title: '1. Information We Collect',
      section2Title: '2. How We Use Your Information',
      section3Title: '3. Data Security',
      section4Title: '4. Your Rights',
      section5Title: '5. Contact Us',
      acceptanceTitle: '1. Acceptance of Terms',
      servicesTitle: '2. Our Services',
      userTitle: '3. User Responsibilities',
      intellectualTitle: '4. Intellectual Property',
      limitationTitle: '5. Limitation of Liability',
      whatAreCookiesTitle: '1. What Are Cookies?',
      howWeUseTitle: '2. How We Use Cookies',
      yourChoicesTitle: '3. Your Cookie Choices',
      updateTitle: '4. Updates to This Policy',
      contactTitle: '5. Contact Information'
    },
    // SEO Keywords
    keywords: 'SRE GLOBAL, SRE GLOBAL TRADING PLATFORM, SRE GLOBAL insurance, SRE GLOBAL Tourism, Yetkili Aracı Kurum, trading platform, mutual funds, insurance services, tourism'
  },
  tr: {
    // Navigation
    nav: {
      group: 'SRE GLOBAL',
      riskKnowledge: 'Risk Bilgisi',
      sustainability: 'Sürdürülebilirlik',
      aboutUs: 'Hakkımızda',
      ourBusiness: 'İşimiz',
      investors: 'Yatırımcılar',
      media: 'Medya',
      careers: 'Kariyer',
      regionalSites: 'Bölgesel Siteler',
      trading: 'Ticaret Platformu',
      insurance: 'Sigorta',
      tourism: 'Turizm',
      clientTools: 'Müşteri Araçları',
      mutualFunds: 'Yatırım Fonları',
      contact: 'İletişim',
      forms: 'Formlar'
    },
    // Hero Section
    hero: {
      title1: 'Önde Gelen Küresel Finansal Hizmetler',
      desc1: 'Modern yatırımcılar için kapsamlı ticaret platformu çözümleri',
      title2: 'Sigorta ve Koruma',
      desc2: 'Kapsamlı sigorta çözümleriyle geleceğinizi güvence altına alın',
      title3: 'Seyahat ve Turizm Mükemmelliği',
      desc3: 'Premium turizm hizmetlerimizle dünyayı keşfedin',
      readMore: 'Devamını Oku'
    },
    // Home Sections
    home: {
      clientTools: 'Müşteri Araçları ve Hizmetleri',
      clientToolsDesc: 'Birçok dijital aracımız hakkında bilgiler ve finans ve sigorta sektöründe çok çeşitli konularda eğitim kursları dahil olmak üzere müşteri araçlarımızı ve hizmetlerimizi keşfedin.',
      exploreTools: 'Müşteri Araçlarını Keşfedin',
      ourGroup: 'GRUBUMUZ',
      groupDesc: 'SRE GLOBAL, ticaret platformları, sigorta ve turizm hizmetlerinin dünya çapında önde gelen sağlayıcılarından biridir ve dünyayı daha dirençli hale getirmek için çalışmaktadır. SRE GLOBAL\'in amacı, müşterilerimiz için yeni fırsatlar ve çözümler yaratarak toplumun gelişmesini ve ilerlemesini sağlamaktır.',
      ourBusiness: 'İşletmelerimiz',
      disclaimer: 'Önemli Bildirim',
      disclaimerText: 'SRE GLOBAL bağımsız bir şirkettir ve Güney Kore veya başka yerlerde benzer isimdeki herhangi bir şirketle bağlantılı, ilişkili veya ortağı değildir. Kendi yönetimimiz, hizmetlerimiz ve operasyonlarımızla bağımsız olarak faaliyet gösteriyoruz.',
      licensesTitle: 'SRE GLOBAL Yetkili Aracı Kurum & FCA Düzenlemesi',
      licensesSubtitle: 'SRE GLOBAL, önde gelen finansal otoriteler tarafından tam yetkili bir aracı kurum olarak düzenlenmiştir, müşterilerimiz için en yüksek güvenlik ve uyumluluk standartlarını sağlar.',
      spkTitle: 'Yetkili Aracı Kurum',
      spkDesc: 'SRE GLOBAL, yetkili aracı kurum statüsüne sahip olup finansal düzenlemelere tam uygunluğu sağlar ve kapsamlı müşteri koruması sunar.',
      spkType: 'Yetki Türü: Yetkili Aracı Kurum',
      fcaTitle: 'İngiltere FCA Lisansı',
      fcaDesc: 'İngiltere Finansal Davranış Otoritesi (FCA) tarafından yetkilendirilmiş ve düzenlenmiştir. FCA lisansımız, en yüksek finansal hizmet standartlarını ve düzenleyici uyumluluğu sürdürme taahhüdümüzü gösterir.',
      fcaType: 'Lisans Türü: Finansal Davranış Otoritesi Yetkisi'
    },
    // Business Sections
    business: {
      trading: {
        title: 'Ticaret Platformu',
        desc: 'Modern yatırımcılar için premium ürünler ve özel çözümlerle kapsamlı bir ticaret platformu sunuyoruz.',
        discover: 'Ticaret Platformunu Keşfedin'
      },
      insurance: {
        title: 'Sigorta Hizmetleri',
        desc: 'Varlıklarınızı, ailenizi ve geleceğinizi kapsamlı sigorta kapsamı ve risk yönetimi çözümleriyle korumaya yardımcı oluyoruz.',
        discover: 'Sigortayı Keşfedin'
      },
      investment: {
        title: 'Yatırım Fonları',
        desc: 'Dünyanın en iyi para yöneticilerinden 18.000\'den fazla fona erişin. Uzman yönetimi, yerleşik çeşitlendirme ve profesyonel portföy çözümleri.',
        discover: 'Yatırım Fonlarını Keşfedin'
      },
      tourism: {
        title: 'Turizm Hizmetleri',
        desc: 'Unutulmaz yolculuklar ve anılar yaratmak için tasarlanmış dünya standartlarında seyahat ve turizm hizmetlerini deneyimleyin.',
        discover: 'Turizmi Keşfedin'
      }
    },
    // Footer
    footer: {
      newsletter: 'Haber Bülteni',
      subscribe: 'Abone Ol',
      contact: 'Bize Ulaşın',
      contactBtn: 'İletişim',
      copyright: '© 2026 SRE GLOBAL. Tüm hakları saklıdır.',
      privacyPolicy: 'Gizlilik Politikası',
      terms: 'Şartlar ve Koşullar',
      cookiePolicy: 'Çerez Politikası',
      regulatedTitle: 'Düzenlenmiş ve Lisanslı',
      spkLicense: 'Yetkili Aracı Kurum:',
      spkLicenseText: 'SRE GLOBAL, yetkili aracı kurum statüsüne sahip olup finansal düzenlemelere uygunluğu sağlar.',
      fcaLicense: '🇬🇧 İngiltere FCA Lisansı:',
      fcaLicenseText: 'SRE GLOBAL, Birleşik Krallık\'ta Finansal Davranış Otoritesi (FCA) tarafından yetkilendirilmiş ve düzenlenmiştir.',
      licenseNote: 'Bu lisanslar, düzenleyici uyumluluk, müşteri koruması ve finansal hizmetlerde en yüksek standartları sürdürme taahhüdümüzü göstermektedir.',
      newsletterPopupTitle: 'Haber Bültenimize Abone Olun',
      newsletterPopupDesc: 'SRE GLOBAL\'den ticaret platformları, yatırım fırsatları ve piyasa bilgileri hakkında en son güncellemeleri alın.',
      newsletterEmailLabel: 'E-posta Adresi',
      newsletterEmailPlaceholder: 'email@ornek.com',
      newsletterSubscribeBtn: 'Şimdi Abone Ol',
      newsletterSuccessTitle: 'Abone Oldunuz!',
      newsletterSuccessDesc: 'Haber bültenimize abone olduğunuz için teşekkür ederiz.',
      newsletterDisclaimer: 'Abone olarak, Gizlilik Politikamızı kabul etmiş olursunuz. İstediğiniz zaman aboneliğinizi iptal edebilirsiniz.'
    },
    // Trading Platform Page
    trading: {
      heroTitle: 'SRE GLOBAL TİCARET PLATFORMU',
      heroDesc: 'Beyaz Etiket Ticaret Çözümleri ve Tam Paket Broker Sistemleri. Kanıtlanmış teknolojimizle kendi ticaret platformunuzu başlatmak için yetkili aracı kurum SRE GLOBAL ile ortaklık yapın.',
      becomePartner: 'Ortak Olun',
      introTitle: 'Beyaz Etiket Ticaret Teknolojisi Sağlayıcısı',
      introDesc1: 'Yetkili aracı kurum olan SRE GLOBAL TİCARET PLATFORMU, beyaz etiket ticaret çözümleri ve anahtar teslimi broker sistemlerinin önde gelen sağlayıcısıdır. Leverate ve MetaQuotes gibi sektör liderlerine benzer şekilde, brokerlerin ve finansal kurumların kendi ticaret platformlarını başlatmasını ve işletmesini sağlayan teknoloji altyapısını sağlıyoruz.',
      introDesc2: 'Son yatırımcılarla doğrudan ticaret yapmıyoruz. Bunun yerine, ortaklarımıza başarılı broker operasyonları yürütmeleri için son teknoloji, kapsamlı CRM sistemleri, risk yönetimi araçları ve tam arka ofis çözümleri sunuyoruz.',
      solutionsTitle: 'Çözümlerimiz',
      whiteLabelTitle: 'Beyaz Etiket Platform',
      whiteLabelDesc: 'Tam özelleştirilebilir beyaz etiket çözümümüzle markalı ticaret platformunuzu başlatın. Marka, özellikler ve kullanıcı deneyimi üzerinde tam kontrol.',
      fullPackageTitle: 'CRM ile Tam Paket',
      fullPackageDesc: 'Gelişmiş CRM, müşteri katılımı, KYC/AML uyumluluğu, ödeme işleme ve raporlama araçlarını içeren eksiksiz broker çözümü.',
      riskManagementTitle: 'Risk Yönetimi Paketi',
      riskManagementDesc: 'Brokerınızı korumak, maruz kalımı izlemek ve gerçek zamanlı analitiksle sürdürülebilir operasyonları sağlamak için gelişmiş risk yönetimi araçları.',
      platformsTitle: 'Ticaret Platformları',
      platformsDesc: 'MetaTrader 4, MetaTrader 5 ve özel web tabanlı ticaret platformları ile entegrasyon. Masaüstü, mobil ve tablet genelinde çoklu cihaz desteği.',
      liquidityTitle: 'Likidite Çözümleri',
      liquidityDesc: 'Birinci sınıf likidite sağlayıcılarımızın ağı aracılığıyla derin likidite havuzlarına, rekabetçi fiyatlandırmaya ve doğrudan piyasa erişimine erişin.',
      techSupportTitle: '7/24 Teknik Destek',
      techSupportDesc: 'Platformunuzun maksimum çalışma süresiyle sorunsuz çalışmasını sağlamak için kesintisiz teknik destek ve bakım.',
      whyChooseTitle: 'Neden SRE GLOBAL\'i Seçmelisiniz?',
      licensedTitle: 'Lisanslı ve Düzenlenmiş',
      licensedDesc: 'Yetkili aracı kurum ve İngiltere FCA tarafından düzenlenmiş, uyumluluk ve güven sağlar.',
      provenTitle: 'Kanıtlanmış Teknoloji',
      provenDesc: 'Kurumsal düzeyde güvenilirlikle binlerce tüccara hizmet veren test edilmiş altyapı.',
      customizableTitle: 'Tam Özelleştirilebilir',
      customizableDesc: 'Markanıza ve iş gereksinimlerinize uyacak şekilde platformun her yönünü özelleştirin.',
      scalableTitle: 'Ölçeklenebilir Altyapı',
      scalableDesc: 'İşletmenizle birlikte büyümek için tasarlandı, başlangıçtan kurumsal düzey operasyonlara kadar.',
      ctaTitle: 'Ticaret Platformunuzu Başlatmaya Hazır mısınız?',
      ctaDesc: 'Lisanslı teknolojimizden yararlanmak ve broker işinizi bugün başlatmak için SRE GLOBAL ile ortaklık yapın.',
      requestDemo: 'Demo Talep Edin'
    },
    // Insurance Page
    insurance: {
      heroTitle: 'SRE GLOBAL sigorta',
      heroDesc: 'Sizi, sevdiklerinizi ve varlıklarınızı korumak için tasarlanmış kapsamlı sigorta çözümleri. SRE GLOBAL sigorta ile hayatın belirsizliklerine karşı korunuyorsunuz.',
      getQuote: 'Ücretsiz Teklifinizi Alın',
      introTitle: 'Güvenilir Sigorta Ortağınız',
      introDesc: 'SRE GLOBAL sigorta, sigorta sektöründe güvenlik ve güvenin direği olarak durmaktadır. Onlarca yıllık deneyim ve mükemmellik taahhüdü ile sizin için en önemli olan şeyleri koruyan kapsamlı sigorta çözümleri sunuyoruz. Bireysel poliçelerden kurumsal kapsama kadar, sigorta hizmetlerimiz belirsiz bir dünyada size huzur sağlamak için tasarlanmıştır.',
      servicesTitle: 'Sigorta Hizmetlerimiz',
      lifeTitle: 'Hayat Sigortası',
      lifeDesc: 'İhtiyaçlarınıza göre uyarlanmış kapsamlı hayat sigortası kapsamıyla ailenizin mali geleceğini koruyun.',
      healthTitle: 'Sağlık Sigortası',
      healthDesc: 'Tıbbi masrafları ve tedavileri kapsayan esnek sağlık sigortası planlarımızla kaliteli sağlık hizmetlerine erişin.',
      propertyTitle: 'Mülk Sigortası',
      propertyDesc: 'Evinizi ve değerli eşyalarınızı hasar, hırsızlık ve doğal afetlere karşı koruyun.',
      businessTitle: 'İş Sigortası',
      businessDesc: 'Sorumluluk, mülk ve işçi tazminatı dahil işletmeler için kapsamlı kapsam.',
      travelTitle: 'Seyahat Sigortası',
      travelDesc: 'Seyahat iptalleri, tıbbi acil durumlar ve kayıp bagaja karşı korunduğunuzu bilerek güvenle seyahat edin.',
      autoTitle: 'Araç Sigortası',
      autoDesc: 'Kazalar, hırsızlık ve üçüncü şahıs sorumluluklarına karşı kapsam ile tam araç koruması.',
      whyChooseTitle: 'Neden SRE GLOBAL Sigorta\'yı Seçmelisiniz?',
      comprehensiveTitle: 'Kapsamlı Kapsam',
      comprehensiveDesc: 'Kişisel ve iş korumasının her yönünü kapsayan kapsamlı sigorta çözümleri.',
      trustedTitle: 'Güvenilir Uzmanlık',
      trustedDesc: 'Onlarca yıllık deneyim ve dünya çapında binlerce memnun müşteri.',
      claimsTitle: 'Hızlı Hasar İşleme',
      claimsDesc: 'Sizi daha hızlı yola döndürmek için hızlı ve verimli hasar yönetimi.',
      customTitle: 'Özelleştirilebilir Planlar',
      customDesc: 'Özel ihtiyaçlarınıza ve bütçenize göre uyarlanmış esnek sigorta planları.',
      getStartedTitle: 'Bugün Başlayın',
      getStartedDesc: 'En önemli olanı koruyun. Ücretsiz bir teklif alın ve sizin için doğru sigorta kapsamını keşfedin.',
      contactUs: 'Bize Ulaşın'
    },
    // Tourism Page
    tourism: {
      heroTitle: 'SRE GLOBAL Turizm',
      heroDesc: 'SRE GLOBAL Turizm ile dünyayı keşfedin. Egzotik destinasyonlardan kültürel deneyimlere kadar, hayallerinize göre özel unutulmaz yolculuklar yaratıyoruz.',
      exploreDest: 'Destinasyonları Keşfedin',
      introTitle: 'Dünyaya Açılan Kapınız',
      introDesc: 'SRE GLOBAL Turizm, unutulmaz deneyimler yaratmak için tasarlanmış premium seyahat ve turizm hizmetleri sunar. İster bir aile tatili, romantik bir kaçamak, iş gezisi veya ömür boyu sürecek bir macera planlıyor olun, uzman ekibimiz beklentileri aşan kişiselleştirilmiş seyahat programları hazırlar.',
      servicesTitle: 'Turizm Hizmetlerimiz',
      packageTitle: 'Tatil Paketleri',
      packageDesc: 'Konaklama, uçuş ve turlar dahil dünyanın en güzel destinasyonlarına özenle hazırlanmış tatil paketleri.',
      culturalTitle: 'Kültürel Turlar',
      culturalDesc: 'Dünya çapında tarihi, sanatı, mutfağı ve yerel gelenekleri keşfeden sürükleyici kültürel deneyimler.',
      adventureTitle: 'Macera Seyahati',
      adventureDesc: 'Adrenalin tutkunları için safari, trekking, dalış ve ekstrem sporlar dahil heyecan verici maceralar.',
      luxuryTitle: 'Lüks Seyahat',
      luxuryDesc: '5 yıldızlı konaklamalar, özel turlar ve kişiselleştirilmiş concierge hizmetleriyle özel lüks deneyimler.',
      businessTitle: 'İş Seyahati',
      businessDesc: 'Uçuşlar, oteller, toplantılar ve etkinlik organizasyonu dahil verimli kurumsal seyahat yönetimi.',
      cruiseTitle: 'Cruise Tatilleri',
      cruiseDesc: 'Konfor ve tarz içinde birden fazla destinasyonu keşfederek unutulmaz cruise deneyimleri.',
      whyChooseTitle: 'Neden SRE GLOBAL ile Seyahat Etmelisiniz?',
      expertTitle: 'Uzman Planlama',
      expertDesc: 'Tercihlerinize göre mükemmel seyahat programları hazırlayan deneyimli seyahat danışmanları.',
      dealsTitle: 'En İyi Fırsatlar',
      dealsDesc: 'Dünya çapında güvenilir ortaklarla rekabetçi fiyatlar ve özel fırsatlar.',
      supportTitle: '7/24 Destek',
      supportDesc: 'Huzur için seyahatleriniz sırasında kesintisiz yardım.',
      personalizedTitle: 'Kişiselleştirilmiş Hizmet',
      personalizedDesc: 'Her yolculuk, ilgi alanlarınıza, bütçenize ve seyahat tarzınıza uyacak şekilde özelleştirilmiştir.',
      startTitle: 'Yolculuğunuza Bugün Başlayın',
      startDesc: 'Dünyayı keşfetmeye hazır mısınız? Bir sonraki unutulmaz maceranızı planlayalım.',
      planTrip: 'Seyahatinizi Planlayın'
    },
    // Contact Page
    contact: {
      heroTitle: 'İletişim',
      heroDesc: 'Yardımcı olmak için buradayız. Bize istediğiniz zaman ulaşın.',
      getInTouch: 'İletişime Geçin',
      getInTouchDesc: 'Hizmetlerimiz hakkında sorularınız mı var? Ortak olmak mı istiyorsunuz? Desteğe mi ihtiyacınız var? Ekibimiz size yardımcı olmaya hazır.',
      officeTitle: 'Ofislerimiz',
      officeAddress: 'SRE GLOBAL, Mythenquai, Zürih, İsviçre',
      emailTitle: 'Bize E-posta Gönderin',
      emailDesc: 'Genel sorular ve destek için',
      businessTitle: 'İş Soruları',
      businessDesc: 'Ortaklık ve iş fırsatları için',
      formTitle: 'Bize Mesaj Gönderin',
      nameLabel: 'Tam Ad',
      namePlaceholder: 'Adınız Soyadınız',
      emailLabel: 'E-posta Adresi',
      emailPlaceholder: 'ornek@email.com',
      subjectLabel: 'Konu',
      subjectPlaceholder: 'Nasıl yardımcı olabiliriz?',
      messageLabel: 'Mesaj',
      messagePlaceholder: 'Sorgunuz hakkında daha fazla bilgi verin...',
      sendMessage: 'Mesaj Gönder',
      successTitle: 'Mesaj Gönderildi!',
      successDesc: 'Bizimle iletişime geçtiğiniz için teşekkür ederiz. 24 saat içinde size geri döneceğiz.'
    },
    // About Page
    about: {
      heroTitle: 'SRE GLOBAL Hakkında',
      heroDesc: 'Küresel ölçekte yenilikçi, güvenli ve müşteri odaklı yatırım çözümleri sunmaya kendini adamış, İsviçre merkezli bir finansal hizmetler şirketi.',
      aboutTitle: 'Hakkımızda',
      aboutPara1: 'SRE GLOBAL, küresel ölçekte yenilikçi, güvenli ve müşteri odaklı yatırım çözümleri sunmaya kendini adamış, İsviçre merkezli bir finansal hizmetler şirketidir. Uluslararası sermaye piyasaları ile ileri finansal teknolojilerin kesişim noktasında faaliyet gösteren şirketimiz, hem bireysel hem de kurumsal yatırımcıların değişen ihtiyaçlarını karşılamak üzere tasarlanmış özel hizmetler sunmaktadır.',
      aboutPara2: 'Ana grubu SWISS RE\'nin gücünden ve mirasından yararlanan SRE GLOBAL, sağlam bir finansal uzmanlık temeli, risk yönetimi mükemmelliği ve küresel piyasa bilgisi üzerine inşa edilmiştir. Bu stratejik konumlanma, güven, şeffaflık ve uzun vadeli değer yaratma üzerine kurulu yüksek kaliteli hizmetler sunmamızı mümkün kılmaktadır.',
      aboutPara3: 'Faaliyetlerimiz, uluslararası düzeyde tanınan düzenleyici standartlarla uyumludur. Grup yapımız aracılığıyla, Birleşik Krallık Finansal Davranış Otoritesi (FCA) dahil olmak üzere kilit finansal otoritelerle uyumluluğumuzu sürdürmekteyiz. Yetkili aracı kurum olarak, bu çok yargı yetkili düzenleyici çerçeve, müşterilerimizin en yüksek düzeyde yönetişim, güvenlik ve operasyonel bütünlüğe uygun hizmetler almasını sağlamaktadır.',
      aboutPara4: 'SRE GLOBAL olarak, portföy yönetimi, yatırım danışmanlığı, sermaye piyasası çözümleri ve risk yönetimi stratejileri dahil olmak üzere geniş bir yelpazede finansal hizmet sunmaktayız. Misyonumuz, müşterilerimizi giderek karmaşıklaşan küresel piyasada sürdürülebilir finansal başarıya ulaşmak için ihtiyaç duydukları araçlar, içgörüler ve fırsatlarla donatmaktır.',
      aboutPara5: 'İnovasyonla yönlendirilen ve uzmanlıkla rehberlik edilen SRE GLOBAL, finansal hizmetlerin her alanında güçlü ortaklıklar kurmaya ve mükemmellik sunmaya devam etmektedir.',
      ourStoryTitle: 'Hikayemiz',
      ourStoryDesc: 'Finansal hizmetleri devrim niteliğinde değiştirme vizyonuyla kurulan SRE GLOBAL, dünya çapında binlerce müşteriye hizmet veren güvenilir bir küresel marka haline geldi. Yolculuğumuz, inovasyon, dürüstlük ve mükemmelliğe olan sarsılmaz taahhüdümüz üzerine kuruludur.',
      missionTitle: 'Misyonumuz',
      missionDesc: 'Müşterilerimizi, giderek karmaşıklaşan küresel piyasada sürdürülebilir finansal başarıya ulaşmak için ihtiyaç duydukları araçlar, içgörüler ve fırsatlarla donatmak.',
      visionTitle: 'Vizyonumuz',
      visionDesc: 'Küresel olarak entegre finansal, sigorta ve turizm hizmetlerinin en güvenilir ve yenilikçi sağlayıcısı olmak.',
      valuesTitle: 'Değerlerimiz',
      integrityTitle: 'Dürüstlük',
      integrityDesc: 'Yaptığımız her şeyde dürüstlük, şeffaflık ve etik uygulamalarla çalışıyoruz.',
      excellenceTitle: 'Mükemmellik',
      excellenceDesc: 'Hizmet sunumunda mükemmelliğe çabalıyor ve tekliflerimizi sürekli iyileştiriyoruz.',
      innovationTitle: 'İnovasyon',
      innovationDesc: 'Son teknoloji çözümler sunmak için teknolojiyi ve inovasyonu benimsiyoruz.',
      trustTitle: 'Güven',
      trustDesc: 'Güven, güvenilirlik ve müşteri memnuniyetine dayalı kalıcı ilişkiler kuruyoruz.',
      globalTitle: 'Küresel Varlık',
      globalDesc: 'Dünya çapındaki ofisleri ve ortaklarıyla SRE GLOBAL, kıtalar genelinde müşterilere hizmet vererek küresel standartlarla yerelleştirilmiş uzmanlık sunmaktadır.'
    },
    // Client Tools Page
    clientTools: {
      heroTitle: 'Müşteri Araçları ve Hizmetleri',
      heroDesc: 'Başarınızı güçlendirmek için tasarlanmış kapsamlı dijital araçlar, eğitim kaynakları ve hizmetler paketimize erişin.',
      toolsTitle: 'Dijital Araçlar',
      toolsDesc: 'Ticaret, yatırım ve hizmet deneyiminizi geliştirmek için tasarlanmış son teknoloji dijital araçlarımızı keşfedin.',
      platformTitle: 'Ticaret Platform Erişimi',
      platformDesc: 'Gerçek zamanlı veri, grafik araçları ve sorunsuz uygulama ile gelişmiş ticaret platformlarımıza erişin.',
      analyticsTitle: 'Piyasa Analizi',
      analyticsDesc: 'Yatırım kararlarınızı bilgilendirmek için derinlemesine piyasa analizi, araştırma raporları ve içgörüler.',
      portfolioTitle: 'Portföy Yöneticisi',
      portfolioDesc: 'Sezgisel portföy yönetim araçlarımızla yatırımlarınızı takip edin ve yönetin.',
      trainingTitle: 'Eğitim ve Öğrenim',
      trainingDesc: 'Kapsamlı eğitim programlarımız ve eğitim kaynaklarımızla bilginizi artırın.',
      webinarsTitle: 'Canlı Webinarlar',
      webinarsDesc: 'Ticaret stratejileri, piyasa trendleri ve daha fazlasını kapsayan sektör uzmanları tarafından sunulan canlı webinarlara katılın.',
      coursesTitle: 'Online Kurslar',
      coursesDesc: 'Başlangıç temellerinden ileri düzey ticaret tekniklerine kadar her şeyi kapsayan kendi hızınızda ilerleyen kurslar.',
      supportTitle: 'Destek Hizmetleri',
      accountTitle: 'Hesap Yönetimi',
      accountDesc: 'İhtiyaçlarınıza yardımcı olmak ve deneyiminizi optimize etmek için özel hesap yöneticileri.',
      techTitle: 'Teknik Destek',
      techDesc: 'Sorunsuz operasyonları ve hızlı sorun çözümünü sağlamak için 7/24 teknik destek.',
      accessTitle: 'Araçlarınıza Erişin',
      accessDesc: 'Tüm mevcut araçlara ve kaynaklara erişmek için müşteri portalınıza giriş yapın.',
      login: 'Müşteri Girişi'
    },
    // Forms Page
    forms: {
      heroTitle: 'Bilgi Talebi',
      heroDesc: 'Aşağıdaki formu doldurun, ekibimiz kısa süre içinde size geri dönecektir.',
      partnerTitle: 'Ortak Olun',
      partnerDesc: 'SRE GLOBAL ile ortaklık kurmakla ilgileniyor musunuz? Görüşmeye başlamak için bu formu doldurun.',
      demoTitle: 'Demo Talep Edin',
      demoDesc: 'Ticaret platformumuzu çalışırken görün. Ekibimizden kişiselleştirilmiş bir demo talep edin.',
      quoteTitle: 'Sigorta Teklifi Alın',
      quoteDesc: 'İhtiyaçlarınıza göre özel, ücretsiz ve bağlayıcı olmayan bir sigorta teklifi alın.',
      tripTitle: 'Seyahat Planlayın',
      tripDesc: 'Hayalinizdeki destinasyon hakkında bize bilgi verin ve mükemmel seyahat programını oluşturalım.',
      generalTitle: 'Genel Soru',
      generalDesc: 'Bir sorunuz mu var veya bilgiye mi ihtiyacınız var? Bize mesaj gönderin.',
      nameLabel: 'Tam Ad',
      namePlaceholder: 'Adınız',
      emailLabel: 'E-posta',
      emailPlaceholder: 'email@ornek.com',
      phoneLabel: 'Telefon (isteğe bağlı)',
      phonePlaceholder: '+905XXXXXXXXX',
      companyLabel: 'Şirket Adı',
      companyPlaceholder: 'Şirketiniz',
      serviceLabel: 'Hizmet İlgisi',
      messageLabel: 'Mesaj',
      messagePlaceholder: 'Daha fazla bilgi verin...',
      submit: 'Talebi Gönder',
      successTitle: 'Talep Gönderildi!',
      successDesc: 'Teşekkürler! 24 saat içinde sizinle iletişime geçeceğiz.'
    },
    // Mutual Funds Page
    mutualFunds: {
      heroTitle: 'Yatırım Fonları',
      heroDesc: 'Dünyanın en iyi para yöneticilerinden 18.000\'den fazla fona erişin. Uzman yönetimi, yerleşik çeşitlendirme ve profesyonel portföy çözümleri.',
      accessFunds: 'Fonlara Erişin',
      introTitle: 'Profesyonel Fon Yönetimi',
      introDesc: 'SRE GLOBAL, dünya çapında önde gelen varlık yöneticilerinden geniş bir yatırım fonu seçkisine erişim sağlar. İster istikrarlı büyüme arayan muhafazakar bir yatırımcı olun, ister daha yüksek getiri arayan agresif bir yatırımcı, her yatırım hedefine ve risk profiline uygun fonlar sunuyoruz.',
      whyTitle: 'Neden Yatırım Fonlarına Yatırım Yapmalısınız?',
      diversificationTitle: 'Çeşitlendirme',
      diversificationDesc: 'Riski azaltmak için yatırımlarınızı birden fazla menkul kıymete yayın.',
      managementTitle: 'Profesyonel Yönetim',
      managementDesc: 'Deneyimli fon yöneticileri sizin adınıza yatırım kararları verir.',
      accessibilityTitle: 'Erişilebilirlik',
      accessibilityDesc: 'Doğrudan hisse senedi alımlarına kıyasla nispeten küçük miktarlarla yatırım yapmaya başlayın.',
      liquidityTitle: 'Likidite',
      liquidityDesc: 'Fon paylarını kolayca alıp satın, portföyünüz için esneklik sağlar.',
      categoriesTitle: 'Fon Kategorileri',
      equityTitle: 'Hisse Senedi Fonları',
      equityDesc: 'Uzun vadeli sermaye artışı ve büyüme potansiyeli için hisse senetlerine yatırım yapın.',
      bondTitle: 'Tahvil Fonları',
      bondDesc: 'Daha düşük riskle düzenli faiz geliri sağlayan sabit getirili yatırımlar.',
      balancedTitle: 'Dengeli Fonlar',
      balancedDesc: 'Dengeli büyüme ve gelir sunan hisse senedi ve tahvil karışımı.',
      indexTitle: 'Endeks Fonları',
      indexDesc: 'Düşük ücretler ve geniş piyasa maruziyeti ile piyasa endekslerini takip edin.',
      getStartedTitle: 'Bugün Yatırım Yapmaya Başlayın',
      getStartedDesc: 'Fon seçimimizi keşfedin ve yatırım portföyünüzü oluşturmaya başlayın.',
      exploreFunds: 'Fonları Keşfedin'
    },
    // Legal Pages
    legal: {
      privacyTitle: 'Gizlilik Politikası',
      privacyEffective: 'Yürürlük Tarihi: 1 Ocak 2026',
      privacyIntro: 'SRE GLOBAL ("biz", "bize" veya "bizim") gizliliğinizi korumaya kararlıdır. Bu Gizlilik Politikası, web sitemizi ziyaret ettiğinizde veya hizmetlerimizi kullandığınızda bilgilerinizi nasıl topladığımızı, kullandığımızı, ifşa ettiğimizi ve koruduğumuzu açıklar.',
      termsTitle: 'Şartlar ve Koşullar',
      termsEffective: 'Yürürlük Tarihi: 1 Ocak 2026',
      termsIntro: 'Bu Şartlar ve Koşullar ("Şartlar") SRE GLOBAL web sitesi ve hizmetlerinin kullanımınızı yönetir. Hizmetlerimize erişerek veya kullanarak, bu Şartlara bağlı olmayı kabul edersiniz.',
      cookieTitle: 'Çerez Politikası',
      cookieEffective: 'Yürürlük Tarihi: 1 Ocak 2026',
      cookieIntro: 'Bu Çerez Politikası, SRE GLOBAL\'in web sitemizi ziyaret ettiğinizde sizi tanımak için çerezleri ve benzer teknolojileri nasıl kullandığını açıklar.',
      section1Title: '1. Topladığımız Bilgiler',
      section2Title: '2. Bilgilerinizi Nasıl Kullanırız',
      section3Title: '3. Veri Güvenliği',
      section4Title: '4. Haklarınız',
      section5Title: '5. Bize Ulaşın',
      acceptanceTitle: '1. Şartların Kabulü',
      servicesTitle: '2. Hizmetlerimiz',
      userTitle: '3. Kullanıcı Sorumlulukları',
      intellectualTitle: '4. Fikri Mülkiyet',
      limitationTitle: '5. Sorumluluk Sınırlaması',
      whatAreCookiesTitle: '1. Çerezler Nedir?',
      howWeUseTitle: '2. Çerezleri Nasıl Kullanırız',
      yourChoicesTitle: '3. Çerez Seçimleriniz',
      updateTitle: '4. Bu Politikada Güncellemeler',
      contactTitle: '5. İletişim Bilgileri'
    },
    // SEO Keywords
    keywords: 'SRE GLOBAL, Yetkili Aracı Kurum, SRE GLOBAL TİCARET PLATFORMU, SRE GLOBAL sigorta, SRE GLOBAL Turizm, ticaret platformu, yatırım fonları, sigorta hizmetleri, turizm'
  },
  de: {
    // Navigation
    nav: {
      group: 'SRE GLOBAL',
      riskKnowledge: 'Risikokenntnisse',
      sustainability: 'Nachhaltigkeit',
      aboutUs: 'Über uns',
      ourBusiness: 'Unser Geschäft',
      investors: 'Investoren',
      media: 'Medien',
      careers: 'Karriere',
      regionalSites: 'Regionale Seiten',
      trading: 'Handelsplattform',
      insurance: 'Versicherung',
      tourism: 'Tourismus',
      clientTools: 'Kundentools',
      mutualFunds: 'Investmentfonds',
      contact: 'Kontakt',
      forms: 'Formulare'
    },
    // Hero Section
    hero: {
      title1: 'Führende globale Finanzdienstleistungen',
      desc1: 'Umfassende Handelsplattformlösungen für moderne Investoren',
      title2: 'Versicherung & Schutz',
      desc2: 'Sichern Sie Ihre Zukunft mit umfassenden Versicherungslösungen',
      title3: 'Reise- & Tourismusexzellenz',
      desc3: 'Entdecken Sie die Welt mit unseren Premium-Tourismusdiensten',
      readMore: 'Mehr erfahren'
    },
    // Home Sections
    home: {
      clientTools: 'Kundentools und -dienste',
      clientToolsDesc: 'Entdecken Sie unsere Kundentools und -dienste, einschließlich Informationen zu unseren vielen digitalen Tools sowie Schulungskurse zu einer Vielzahl von Themen in der Finanz- und Versicherungsbranche.',
      exploreTools: 'Kundentools erkunden',
      ourGroup: 'UNSERE GRUPPE',
      groupDesc: 'SRE GLOBAL ist einer der weltweit führenden Anbieter von Handelsplattformen, Versicherungen und Tourismusdienstleistungen und arbeitet daran, die Welt widerstandsfähiger zu machen.',
      ourBusiness: 'Unsere Geschäfte',
      disclaimer: 'Wichtiger Hinweis',
      disclaimerText: 'SRE GLOBAL ist ein unabhängiges Unternehmen und ist nicht verbunden mit einem Unternehmen ähnlichen Namens in Südkorea oder anderswo.',
      licensesTitle: 'SRE GLOBAL Yetkili Aracı Kurum & FCA Regulierung',
      licensesSubtitle: 'SRE GLOBAL ist ein vollständig autorisiertes Maklerunternehmen, reguliert von führenden Finanzbehörden.',
      spkTitle: 'Yetkili Aracı Kurum',
      spkDesc: 'SRE GLOBAL ist ein autorisiertes Maklerunternehmen (Yetkili Aracı Kurum), das die Einhaltung der Finanzvorschriften gewährleistet.',
      spkType: 'Autorisierungstyp: Autorisiertes Maklerunternehmen',
      fcaTitle: 'UK FCA-Lizenz',
      fcaDesc: 'Autorisiert und reguliert von der britischen Financial Conduct Authority.',
      fcaType: 'Lizenztyp: Financial Conduct Authority Autorisierung'
    },
    // Business Sections
    business: {
      trading: {
        title: 'Handelsplattform',
        desc: 'Wir bieten Ihnen eine umfassende Handelsplattform mit Premium-Produkten und maßgeschneiderten Lösungen.',
        discover: 'Handelsplattform entdecken'
      },
      insurance: {
        title: 'Versicherungsdienstleistungen',
        desc: 'Wir helfen, Ihre Vermögenswerte, Familie und Zukunft mit umfassender Versicherungsdeckung zu schützen.',
        discover: 'Versicherung entdecken'
      },
      investment: {
        title: 'Investmentfonds',
        desc: 'Zugang zu über 18.000 Fonds der weltbesten Vermögensverwalter.',
        discover: 'Investmentfonds entdecken'
      },
      tourism: {
        title: 'Tourismusdienstleistungen',
        desc: 'Erleben Sie erstklassige Reise- und Tourismusdienste für unvergessliche Reisen.',
        discover: 'Tourismus entdecken'
      }
    },
    // Footer
    footer: {
      newsletter: 'Newsletter',
      subscribe: 'Abonnieren',
      contact: 'Kontaktieren Sie uns',
      contactBtn: 'Kontakt',
      copyright: '© 2026 SRE GLOBAL. Alle Rechte vorbehalten.',
      privacyPolicy: 'Datenschutz',
      terms: 'AGB',
      cookiePolicy: 'Cookie-Richtlinie',
      regulatedTitle: 'Reguliert & Lizenziert',
      spkLicense: 'Yetkili Aracı Kurum:',
      spkLicenseText: 'SRE GLOBAL ist ein autorisiertes Maklerunternehmen (Yetkili Aracı Kurum).',
      fcaLicense: '🇬🇧 UK FCA-Lizenz:',
      fcaLicenseText: 'SRE GLOBAL ist von der Financial Conduct Authority (FCA) im Vereinigten Königreich autorisiert und reguliert.',
      licenseNote: 'Diese Lizenzen zeigen unser Engagement für regulatorische Compliance und Kundenschutz.',
      newsletterPopupTitle: 'Abonnieren Sie unseren Newsletter',
      newsletterPopupDesc: 'Erhalten Sie die neuesten Updates zu Handelsplattformen, Investitionsmöglichkeiten und Markteinblicken von SRE GLOBAL.',
      newsletterEmailLabel: 'E-Mail-Adresse',
      newsletterEmailPlaceholder: 'ihre@email.de',
      newsletterSubscribeBtn: 'Jetzt abonnieren',
      newsletterSuccessTitle: 'Abonniert!',
      newsletterSuccessDesc: 'Vielen Dank für das Abonnieren unseres Newsletters.',
      newsletterDisclaimer: 'Durch das Abonnieren stimmen Sie unserer Datenschutzrichtlinie zu. Sie können sich jederzeit abmelden.'
    },
    // Trading Platform Page
    trading: {
      heroTitle: 'SRE GLOBAL HANDELSPLATTFORM',
      heroDesc: 'White-Label-Handelslösungen und Full-Package-Broker-Systeme.',
      becomePartner: 'Partner werden',
      introTitle: 'White-Label-Handelstechnologieanbieter',
      introDesc1: 'SRE GLOBAL HANDELSPLATTFORM ist ein führender Anbieter von White-Label-Handelslösungen.',
      introDesc2: 'Wir handeln nicht direkt mit Endinvestoren, sondern befähigen unsere Partner mit modernster Technologie.',
      solutionsTitle: 'Unsere Lösungen',
      whiteLabelTitle: 'White-Label-Plattform',
      whiteLabelDesc: 'Starten Sie Ihre eigene Handelsplattform mit unserer vollständig anpassbaren Lösung.',
      fullPackageTitle: 'Komplettpaket mit CRM',
      fullPackageDesc: 'Komplette Broker-Lösung mit fortschrittlichem CRM und Compliance-Tools.',
      riskManagementTitle: 'Risikomanagement-Suite',
      riskManagementDesc: 'Fortschrittliche Risikomanagement-Tools zum Schutz Ihres Brokerages.',
      platformsTitle: 'Handelsplattformen',
      platformsDesc: 'Integration mit MetaTrader 4, MetaTrader 5 und benutzerdefinierten Plattformen.',
      liquidityTitle: 'Liquiditätslösungen',
      liquidityDesc: 'Zugang zu tiefen Liquiditätspools und wettbewerbsfähigen Preisen.',
      techSupportTitle: '24/7 Technischer Support',
      techSupportDesc: 'Rund-um-die-Uhr-Support zur Gewährleistung eines reibungslosen Betriebs.',
      whyChooseTitle: 'Warum SRE GLOBAL?',
      licensedTitle: 'Lizenziert & Reguliert',
      licensedDesc: 'Autorisiertes Maklerunternehmen (Yetkili Aracı Kurum) und UK FCA reguliert.',
      provenTitle: 'Bewährte Technologie',
      provenDesc: 'Kampferprobte Infrastruktur mit institutioneller Zuverlässigkeit.',
      customizableTitle: 'Vollständig anpassbar',
      customizableDesc: 'Passen Sie jeden Aspekt an Ihre Marke an.',
      scalableTitle: 'Skalierbare Infrastruktur',
      scalableDesc: 'Wächst mit Ihrem Unternehmen.',
      ctaTitle: 'Bereit, Ihre Handelsplattform zu starten?',
      ctaDesc: 'Partnern Sie mit SRE GLOBAL, um Ihr Brokerage-Geschäft zu starten.',
      requestDemo: 'Demo anfordern'
    },
    // Insurance Page
    insurance: {
      heroTitle: 'SRE GLOBAL Versicherung',
      heroDesc: 'Umfassende Versicherungslösungen zum Schutz Ihrer Lieben und Vermögenswerte.',
      getQuote: 'Kostenloses Angebot erhalten',
      introTitle: 'Ihr vertrauenswürdiger Versicherungspartner',
      introDesc: 'SRE GLOBAL Versicherung bietet umfassende Versicherungslösungen für Einzelpersonen und Unternehmen.',
      servicesTitle: 'Unsere Versicherungsdienstleistungen',
      lifeTitle: 'Lebensversicherung',
      lifeDesc: 'Schützen Sie die finanzielle Zukunft Ihrer Familie.',
      healthTitle: 'Krankenversicherung',
      healthDesc: 'Zugang zu hochwertiger Gesundheitsversorgung.',
      propertyTitle: 'Sachversicherung',
      propertyDesc: 'Schützen Sie Ihr Zuhause und wertvolle Besitztümer.',
      businessTitle: 'Betriebsversicherung',
      businessDesc: 'Umfassender Schutz für Unternehmen.',
      travelTitle: 'Reiseversicherung',
      travelDesc: 'Reisen Sie mit Vertrauen.',
      autoTitle: 'Kfz-Versicherung',
      autoDesc: 'Kompletter Fahrzeugschutz.',
      whyChooseTitle: 'Warum SRE GLOBAL Versicherung?',
      comprehensiveTitle: 'Umfassender Schutz',
      comprehensiveDesc: 'Umfangreiche Versicherungslösungen.',
      trustedTitle: 'Vertrauenswürdige Expertise',
      trustedDesc: 'Jahrzehnte Erfahrung.',
      claimsTitle: 'Schnelle Schadensbearbeitung',
      claimsDesc: 'Effiziente Schadensabwicklung.',
      customTitle: 'Anpassbare Pläne',
      customDesc: 'Flexible Versicherungspläne.',
      getStartedTitle: 'Heute beginnen',
      getStartedDesc: 'Holen Sie sich ein kostenloses Angebot.',
      contactUs: 'Kontaktieren Sie uns'
    },
    // Tourism Page
    tourism: {
      heroTitle: 'SRE GLOBAL Tourismus',
      heroDesc: 'Entdecken Sie die Welt mit SRE GLOBAL Tourismus.',
      exploreDest: 'Reiseziele erkunden',
      introTitle: 'Ihr Tor zur Welt',
      introDesc: 'SRE GLOBAL Tourismus bietet erstklassige Reise- und Tourismusdienstleistungen.',
      servicesTitle: 'Unsere Tourismusdienstleistungen',
      packageTitle: 'Urlaubspakete',
      packageDesc: 'Kuratierte Urlaubspakete zu den schönsten Zielen der Welt.',
      culturalTitle: 'Kulturreisen',
      culturalDesc: 'Immersive kulturelle Erlebnisse.',
      adventureTitle: 'Abenteuerreisen',
      adventureDesc: 'Aufregende Abenteuer für Adrenalinjunkies.',
      luxuryTitle: 'Luxusreisen',
      luxuryDesc: 'Exklusive Luxuserlebnisse.',
      businessTitle: 'Geschäftsreisen',
      businessDesc: 'Effizientes Corporate Travel Management.',
      cruiseTitle: 'Kreuzfahrten',
      cruiseDesc: 'Unvergessliche Kreuzfahrterlebnisse.',
      whyChooseTitle: 'Warum mit SRE GLOBAL reisen?',
      expertTitle: 'Expertenplanung',
      expertDesc: 'Erfahrene Reiseberater.',
      dealsTitle: 'Beste Angebote',
      dealsDesc: 'Wettbewerbsfähige Preise.',
      supportTitle: '24/7 Support',
      supportDesc: 'Rund-um-die-Uhr-Unterstützung.',
      personalizedTitle: 'Personalisierter Service',
      personalizedDesc: 'Jede Reise ist maßgeschneidert.',
      startTitle: 'Starten Sie Ihre Reise heute',
      startDesc: 'Bereit, die Welt zu erkunden?',
      planTrip: 'Reise planen'
    },
    // Contact Page
    contact: {
      heroTitle: 'Kontakt',
      heroDesc: 'Wir sind hier, um zu helfen.',
      getInTouch: 'Kontakt aufnehmen',
      getInTouchDesc: 'Haben Sie Fragen zu unseren Dienstleistungen?',
      officeTitle: 'Unsere Büros',
      officeAddress: 'SRE GLOBAL, Mythenquai, Zürich, Schweiz',
      emailTitle: 'Senden Sie uns eine E-Mail',
      emailDesc: 'Für allgemeine Anfragen und Support',
      businessTitle: 'Geschäftsanfragen',
      businessDesc: 'Für Partnerschaft und Geschäftsmöglichkeiten',
      formTitle: 'Senden Sie uns eine Nachricht',
      nameLabel: 'Vollständiger Name',
      namePlaceholder: 'Ihr Name',
      emailLabel: 'E-Mail-Adresse',
      emailPlaceholder: 'ihre@email.de',
      subjectLabel: 'Betreff',
      subjectPlaceholder: 'Wie können wir helfen?',
      messageLabel: 'Nachricht',
      messagePlaceholder: 'Erzählen Sie uns mehr...',
      sendMessage: 'Nachricht senden',
      successTitle: 'Nachricht gesendet!',
      successDesc: 'Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.'
    },
    // About Page
    about: {
      heroTitle: 'Über SRE GLOBAL',
      heroDesc: 'Ein in der Schweiz ansässiges Finanzdienstleistungsunternehmen, das sich der Bereitstellung innovativer, sicherer und kundenorientierter Anlagelösungen auf globaler Ebene verschrieben hat.',
      aboutTitle: 'Über uns',
      aboutPara1: 'SRE GLOBAL ist ein in der Schweiz ansässiges Finanzdienstleistungsunternehmen, das sich der Bereitstellung innovativer, sicherer und kundenorientierter Anlagelösungen auf globaler Ebene verschrieben hat. An der Schnittstelle internationaler Kapitalmärkte und fortschrittlicher Finanztechnologien bieten wir maßgeschneiderte Dienstleistungen, die auf die sich wandelnden Bedürfnisse sowohl privater als auch institutioneller Anleger zugeschnitten sind.',
      aboutPara2: 'Als Unternehmen, das von der Stärke und dem Erbe seiner Muttergesellschaft SWISS RE profitiert, verfügt SRE GLOBAL über ein solides Fundament an Finanzexpertise, Risikomanagement-Exzellenz und globalem Marktverständnis. Diese strategische Positionierung ermöglicht es uns, hochwertige Dienstleistungen anzubieten, die auf Vertrauen, Transparenz und langfristiger Wertschöpfung basieren.',
      aboutPara3: 'Unsere Geschäftstätigkeit ist an international anerkannten regulatorischen Standards ausgerichtet. Über unsere Konzernstruktur wahren wir die Konformität mit wichtigen Finanzaufsichtsbehörden, darunter die britische Financial Conduct Authority (FCA). Als autorisiertes Maklerunternehmen (Yetkili Aracı Kurum) stellt dieser multi-jurisdiktionale regulatorische Rahmen sicher, dass unsere Kunden Dienstleistungen erhalten, die den höchsten Standards entsprechen.',
      aboutPara4: 'Bei SRE GLOBAL sind wir auf ein breites Spektrum von Finanzdienstleistungen spezialisiert, darunter Portfoliomanagement, Anlageberatung, Kapitalmarktlösungen und Risikomanagementstrategien. Unsere Mission ist es, unsere Kunden mit den Werkzeugen, Erkenntnissen und Möglichkeiten auszustatten, die sie benötigen, um nachhaltigen finanziellen Erfolg in einem zunehmend komplexen globalen Markt zu erzielen.',
      aboutPara5: 'Angetrieben von Innovation und geleitet von Expertise, baut SRE GLOBAL weiterhin starke Partnerschaften auf und liefert Exzellenz in allen Bereichen der Finanzdienstleistungen.',
      ourStoryTitle: 'Unsere Geschichte',
      ourStoryDesc: 'SRE GLOBAL ist zu einer vertrauenswürdigen globalen Marke gewachsen.',
      missionTitle: 'Unsere Mission',
      missionDesc: 'Unsere Kunden mit den Werkzeugen, Erkenntnissen und Möglichkeiten auszustatten, die sie für nachhaltigen finanziellen Erfolg in einem zunehmend komplexen globalen Markt benötigen.',
      visionTitle: 'Unsere Vision',
      visionDesc: 'Der vertrauenswürdigste und innovativste Anbieter integrierter Finanz-, Versicherungs- und Tourismusdienstleistungen weltweit zu werden.',
      valuesTitle: 'Unsere Werte',
      integrityTitle: 'Integrität',
      integrityDesc: 'Wir arbeiten mit Ehrlichkeit, Transparenz und ethischen Praktiken in allem, was wir tun.',
      excellenceTitle: 'Exzellenz',
      excellenceDesc: 'Wir streben nach Exzellenz in der Servicebereitstellung und verbessern unser Angebot kontinuierlich.',
      innovationTitle: 'Innovation',
      innovationDesc: 'Wir nutzen Technologie und Innovation, um modernste Lösungen anzubieten.',
      trustTitle: 'Vertrauen',
      trustDesc: 'Wir bauen dauerhafte Beziehungen auf, die auf Vertrauen, Zuverlässigkeit und Kundenzufriedenheit basieren.',
      globalTitle: 'Globale Präsenz',
      globalDesc: 'Mit Büros und Partnern auf der ganzen Welt bedient SRE GLOBAL Kunden auf allen Kontinenten und liefert lokalisierte Expertise mit globalen Standards.'
    },
    // Client Tools Page
    clientTools: {
      heroTitle: 'Kundentools & -dienste',
      heroDesc: 'Greifen Sie auf unsere umfassende Suite digitaler Tools zu.',
      toolsTitle: 'Digitale Tools',
      toolsDesc: 'Entdecken Sie unsere modernsten digitalen Tools.',
      platformTitle: 'Handelsplattform-Zugang',
      platformDesc: 'Zugang zu fortschrittlichen Handelsplattformen.',
      analyticsTitle: 'Marktanalyse',
      analyticsDesc: 'Tiefgehende Marktanalyse.',
      portfolioTitle: 'Portfolio-Manager',
      portfolioDesc: 'Verwalten Sie Ihre Investitionen.',
      trainingTitle: 'Schulung & Bildung',
      trainingDesc: 'Umfassende Schulungsprogramme.',
      webinarsTitle: 'Live-Webinare',
      webinarsDesc: 'Von Branchenexperten gehostete Webinare.',
      coursesTitle: 'Online-Kurse',
      coursesDesc: 'Selbstgesteuerte Kurse.',
      supportTitle: 'Support-Dienste',
      accountTitle: 'Kontoverwaltung',
      accountDesc: 'Dedizierte Account-Manager.',
      techTitle: 'Technischer Support',
      techDesc: '24/7 technischer Support.',
      accessTitle: 'Zugang zu Ihren Tools',
      accessDesc: 'Melden Sie sich im Kundenportal an.',
      login: 'Kundenanmeldung'
    },
    // Forms Page
    forms: {
      heroTitle: 'Informationen anfordern',
      heroDesc: 'Füllen Sie das Formular aus.',
      partnerTitle: 'Partner werden',
      partnerDesc: 'Interessiert an einer Partnerschaft?',
      demoTitle: 'Demo anfordern',
      demoDesc: 'Sehen Sie unsere Plattform in Aktion.',
      quoteTitle: 'Versicherungsangebot erhalten',
      quoteDesc: 'Kostenloses Versicherungsangebot.',
      tripTitle: 'Reise planen',
      tripDesc: 'Erzählen Sie uns von Ihrem Traumziel.',
      generalTitle: 'Allgemeine Anfrage',
      generalDesc: 'Haben Sie eine Frage?',
      nameLabel: 'Vollständiger Name',
      namePlaceholder: 'Ihr Name',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'ihre@email.de',
      phoneLabel: 'Telefon (optional)',
      phonePlaceholder: '+49',
      companyLabel: 'Firmenname',
      companyPlaceholder: 'Ihre Firma',
      serviceLabel: 'Service-Interesse',
      messageLabel: 'Nachricht',
      messagePlaceholder: 'Erzählen Sie uns mehr...',
      submit: 'Anfrage senden',
      successTitle: 'Anfrage gesendet!',
      successDesc: 'Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.'
    },
    // Mutual Funds Page
    mutualFunds: {
      heroTitle: 'Investmentfonds',
      heroDesc: 'Zugang zu über 18.000 Fonds.',
      accessFunds: 'Zugang zu Fonds',
      introTitle: 'Professionelles Fondsmanagement',
      introDesc: 'SRE GLOBAL bietet Zugang zu einer umfangreichen Auswahl an Investmentfonds.',
      whyTitle: 'Warum in Investmentfonds investieren?',
      diversificationTitle: 'Diversifikation',
      diversificationDesc: 'Verteilen Sie Ihre Investitionen.',
      managementTitle: 'Professionelles Management',
      managementDesc: 'Erfahrene Fondsmanager.',
      accessibilityTitle: 'Zugänglichkeit',
      accessibilityDesc: 'Beginnen Sie mit kleinen Beträgen.',
      liquidityTitle: 'Liquidität',
      liquidityDesc: 'Einfach kaufen und verkaufen.',
      categoriesTitle: 'Fondskategorien',
      equityTitle: 'Aktienfonds',
      equityDesc: 'In Aktien investieren.',
      bondTitle: 'Anleihenfonds',
      bondDesc: 'Festzinsanlagen.',
      balancedTitle: 'Ausgewogene Fonds',
      balancedDesc: 'Mischung aus Aktien und Anleihen.',
      indexTitle: 'Indexfonds',
      indexDesc: 'Marktindizes nachverfolgen.',
      getStartedTitle: 'Heute investieren',
      getStartedDesc: 'Beginnen Sie mit dem Aufbau Ihres Portfolios.',
      exploreFunds: 'Fonds erkunden'
    },
    // Legal Pages
    legal: {
      privacyTitle: 'Datenschutzerklärung',
      privacyEffective: 'Gültig ab: 1. Januar 2026',
      privacyIntro: 'SRE GLOBAL ("wir", "uns" oder "unser") verpflichtet sich zum Schutz Ihrer Privatsphäre. Diese Datenschutzerklärung erklärt, wie wir Ihre Informationen sammeln, verwenden, offenlegen und schützen, wenn Sie unsere Website besuchen oder unsere Dienste nutzen.',
      termsTitle: 'Allgemeine Geschäftsbedingungen',
      termsEffective: 'Gültig ab: 1. Januar 2026',
      termsIntro: 'Diese Allgemeinen Geschäftsbedingungen ("Bedingungen") regeln Ihre Nutzung der SRE GLOBAL-Website und -Dienste. Durch den Zugriff auf oder die Nutzung unserer Dienste stimmen Sie diesen Bedingungen zu.',
      cookieTitle: 'Cookie-Richtlinie',
      cookieEffective: 'Gültig ab: 1. Januar 2026',
      cookieIntro: 'Diese Cookie-Richtlinie erklärt, wie SRE GLOBAL Cookies und ähnliche Technologien verwendet, um Sie zu erkennen, wenn Sie unsere Website besuchen.',
      section1Title: '1. Informationen, die wir sammeln',
      section2Title: '2. Wie wir Ihre Informationen verwenden',
      section3Title: '3. Datensicherheit',
      section4Title: '4. Ihre Rechte',
      section5Title: '5. Kontaktieren Sie uns',
      acceptanceTitle: '1. Annahme der Bedingungen',
      servicesTitle: '2. Unsere Dienstleistungen',
      userTitle: '3. Benutzerverantwortung',
      intellectualTitle: '4. Geistiges Eigentum',
      limitationTitle: '5. Haftungsbeschränkung',
      whatAreCookiesTitle: '1. Was sind Cookies?',
      howWeUseTitle: '2. Wie wir Cookies verwenden',
      yourChoicesTitle: '3. Ihre Cookie-Auswahl',
      updateTitle: '4. Aktualisierungen dieser Richtlinie',
      contactTitle: '5. Kontaktinformationen'
    },
    // SEO Keywords
    keywords: 'SRE GLOBAL, Yetkili Aracı Kurum, SRE GLOBAL HANDELSPLATTFORM, SRE GLOBAL Versicherung, SRE GLOBAL Tourismus'
  },
  fr: {
    // Navigation
    nav: {
      group: 'SRE GLOBAL',
      riskKnowledge: 'Connaissance des risques',
      sustainability: 'Durabilité',
      aboutUs: 'À propos',
      ourBusiness: 'Notre activité',
      investors: 'Investisseurs',
      media: 'Médias',
      careers: 'Carrières',
      regionalSites: 'Sites régionaux',
      trading: 'Plateforme de trading',
      insurance: 'Assurance',
      tourism: 'Tourisme',
      clientTools: 'Outils clients',
      mutualFunds: 'Fonds communs',
      contact: 'Contact',
      forms: 'Formulaires'
    },
    // Hero Section
    hero: {
      title1: 'Services financiers mondiaux de premier plan',
      desc1: 'Solutions de plateforme de trading complètes pour les investisseurs modernes',
      title2: 'Assurance & Protection',
      desc2: 'Protégez votre avenir avec des solutions d\'assurance complètes',
      title3: 'Excellence du voyage et du tourisme',
      desc3: 'Découvrez le monde avec nos services touristiques premium',
      readMore: 'En savoir plus'
    },
    // Home Sections
    home: {
      clientTools: 'Outils et services clients',
      clientToolsDesc: 'Découvrez nos outils et services clients, y compris des informations sur nos nombreux outils numériques ainsi que des cours de formation sur un large éventail de sujets dans l\'industrie financière et de l\'assurance.',
      exploreTools: 'Explorer les outils clients',
      ourGroup: 'NOTRE GROUPE',
      groupDesc: 'SRE GLOBAL est l\'un des principaux fournisseurs mondiaux de plateformes de trading, d\'assurances et de services touristiques, travaillant à rendre le monde plus résilient.',
      ourBusiness: 'Nos activités',
      disclaimer: 'Avis important',
      disclaimerText: 'SRE GLOBAL est une société indépendante et n\'est pas affiliée à une société de nom similaire basée en Corée du Sud ou ailleurs.',
      licensesTitle: 'SRE GLOBAL Yetkili Aracı Kurum & Régulation FCA',
      licensesSubtitle: 'SRE GLOBAL est une société de courtage entièrement autorisée, réglementée par les principales autorités financières.',
      spkTitle: 'Yetkili Aracı Kurum',
      spkDesc: 'SRE GLOBAL est une société de courtage autorisée (Yetkili Aracı Kurum), garantissant la conformité aux réglementations financières.',
      spkType: 'Type d\'autorisation: Société de courtage autorisée',
      fcaTitle: 'Licence FCA britannique',
      fcaDesc: 'Autorisé et réglementé par la Financial Conduct Authority du Royaume-Uni.',
      fcaType: 'Type de licence: Autorisation de la Financial Conduct Authority'
    },
    // Business Sections
    business: {
      trading: {
        title: 'Plateforme de trading',
        desc: 'Nous vous proposons une plateforme de trading complète avec des produits premium et des solutions sur mesure.',
        discover: 'Découvrir la plateforme de trading'
      },
      insurance: {
        title: 'Services d\'assurance',
        desc: 'Nous aidons à protéger vos actifs, votre famille et votre avenir avec une couverture d\'assurance complète.',
        discover: 'Découvrir l\'assurance'
      },
      investment: {
        title: 'Fonds communs de placement',
        desc: 'Accès à plus de 18 000 fonds des meilleurs gestionnaires de fonds du monde.',
        discover: 'Découvrir les fonds communs'
      },
      tourism: {
        title: 'Services touristiques',
        desc: 'Découvrez des services de voyage et de tourisme de classe mondiale pour des voyages inoubliables.',
        discover: 'Découvrir le tourisme'
      }
    },
    // Footer
    footer: {
      newsletter: 'Newsletter',
      subscribe: 'S\'abonner',
      contact: 'Nous contacter',
      contactBtn: 'Contact',
      copyright: '© 2026 SRE GLOBAL. Tous droits réservés.',
      privacyPolicy: 'Politique de confidentialité',
      terms: 'Conditions générales',
      cookiePolicy: 'Politique des cookies',
      regulatedTitle: 'Réglementé & Licencié',
      spkLicense: 'Yetkili Aracı Kurum:',
      spkLicenseText: 'SRE GLOBAL est une société de courtage autorisée (Yetkili Aracı Kurum).',
      fcaLicense: '🇬🇧 Licence FCA britannique:',
      fcaLicenseText: 'SRE GLOBAL est autorisé et réglementé par la Financial Conduct Authority (FCA) au Royaume-Uni.',
      licenseNote: 'Ces licences démontrent notre engagement envers la conformité réglementaire et la protection des clients.',
      newsletterPopupTitle: 'Abonnez-vous à notre newsletter',
      newsletterPopupDesc: 'Recevez les dernières mises à jour sur les plateformes de trading, les opportunités d\'investissement et les informations de marché de SRE GLOBAL.',
      newsletterEmailLabel: 'Adresse e-mail',
      newsletterEmailPlaceholder: 'votre@email.fr',
      newsletterSubscribeBtn: 'S\'abonner maintenant',
      newsletterSuccessTitle: 'Abonné!',
      newsletterSuccessDesc: 'Merci de vous être abonné à notre newsletter.',
      newsletterDisclaimer: 'En vous abonnant, vous acceptez notre Politique de confidentialité. Vous pouvez vous désabonner à tout moment.'
    },
    // Trading Platform Page
    trading: {
      heroTitle: 'PLATEFORME DE TRADING SRE GLOBAL',
      heroDesc: 'Solutions de trading en marque blanche et systèmes de courtage complets.',
      becomePartner: 'Devenir partenaire',
      introTitle: 'Fournisseur de technologie de trading en marque blanche',
      introDesc1: 'La PLATEFORME DE TRADING SRE GLOBAL est un fournisseur leader de solutions de trading en marque blanche.',
      introDesc2: 'Nous ne négocions pas directement avec les investisseurs finaux, mais donnons à nos partenaires une technologie de pointe.',
      solutionsTitle: 'Nos solutions',
      whiteLabelTitle: 'Plateforme en marque blanche',
      whiteLabelDesc: 'Lancez votre propre plateforme de trading avec notre solution entièrement personnalisable.',
      fullPackageTitle: 'Forfait complet avec CRM',
      fullPackageDesc: 'Solution de courtage complète avec CRM avancé et outils de conformité.',
      riskManagementTitle: 'Suite de gestion des risques',
      riskManagementDesc: 'Outils avancés de gestion des risques pour protéger votre courtage.',
      platformsTitle: 'Plateformes de trading',
      platformsDesc: 'Intégration avec MetaTrader 4, MetaTrader 5 et plateformes personnalisées.',
      liquidityTitle: 'Solutions de liquidité',
      liquidityDesc: 'Accès à des pools de liquidité profonds et des prix compétitifs.',
      techSupportTitle: 'Support technique 24/7',
      techSupportDesc: 'Support 24h/24 pour assurer un fonctionnement fluide.',
      whyChooseTitle: 'Pourquoi choisir SRE GLOBAL?',
      licensedTitle: 'Licencié & réglementé',
      licensedDesc: 'Société de courtage autorisée (Yetkili Aracı Kurum) et réglementée par la FCA britannique.',
      provenTitle: 'Technologie éprouvée',
      provenDesc: 'Infrastructure testée au combat avec fiabilité institutionnelle.',
      customizableTitle: 'Entièrement personnalisable',
      customizableDesc: 'Adaptez chaque aspect à votre marque.',
      scalableTitle: 'Infrastructure évolutive',
      scalableDesc: 'Construit pour grandir avec votre entreprise.',
      ctaTitle: 'Prêt à lancer votre plateforme de trading?',
      ctaDesc: 'Associez-vous à SRE GLOBAL pour démarrer votre entreprise de courtage.',
      requestDemo: 'Demander une démo'
    },
    // Insurance Page
    insurance: {
      heroTitle: 'Assurance SRE GLOBAL',
      heroDesc: 'Solutions d\'assurance complètes pour protéger vos proches et vos actifs.',
      getQuote: 'Obtenir un devis gratuit',
      introTitle: 'Votre partenaire d\'assurance de confiance',
      introDesc: 'L\'assurance SRE GLOBAL offre des solutions d\'assurance complètes pour les particuliers et les entreprises.',
      servicesTitle: 'Nos services d\'assurance',
      lifeTitle: 'Assurance-vie',
      lifeDesc: 'Protégez l\'avenir financier de votre famille.',
      healthTitle: 'Assurance santé',
      healthDesc: 'Accès à des soins de santé de qualité.',
      propertyTitle: 'Assurance habitation',
      propertyDesc: 'Protégez votre maison et vos biens précieux.',
      businessTitle: 'Assurance professionnelle',
      businessDesc: 'Couverture complète pour les entreprises.',
      travelTitle: 'Assurance voyage',
      travelDesc: 'Voyagez en toute confiance.',
      autoTitle: 'Assurance auto',
      autoDesc: 'Protection complète du véhicule.',
      whyChooseTitle: 'Pourquoi choisir l\'assurance SRE GLOBAL?',
      comprehensiveTitle: 'Couverture complète',
      comprehensiveDesc: 'Solutions d\'assurance étendues.',
      trustedTitle: 'Expertise de confiance',
      trustedDesc: 'Des décennies d\'expérience.',
      claimsTitle: 'Traitement rapide des réclamations',
      claimsDesc: 'Gestion efficace des sinistres.',
      customTitle: 'Plans personnalisables',
      customDesc: 'Plans d\'assurance flexibles.',
      getStartedTitle: 'Commencez aujourd\'hui',
      getStartedDesc: 'Obtenez un devis gratuit.',
      contactUs: 'Contactez-nous'
    },
    // Tourism Page
    tourism: {
      heroTitle: 'Tourisme SRE GLOBAL',
      heroDesc: 'Découvrez le monde avec le tourisme SRE GLOBAL.',
      exploreDest: 'Explorer les destinations',
      introTitle: 'Votre porte d\'entrée vers le monde',
      introDesc: 'Le tourisme SRE GLOBAL offre des services de voyage et de tourisme premium.',
      servicesTitle: 'Nos services touristiques',
      packageTitle: 'Forfaits vacances',
      packageDesc: 'Forfaits vacances organisés vers les plus belles destinations du monde.',
      culturalTitle: 'Circuits culturels',
      culturalDesc: 'Expériences culturelles immersives.',
      adventureTitle: 'Voyage d\'aventure',
      adventureDesc: 'Aventures passionnantes pour les amateurs de sensations fortes.',
      luxuryTitle: 'Voyage de luxe',
      luxuryDesc: 'Expériences de luxe exclusives.',
      businessTitle: 'Voyages d\'affaires',
      businessDesc: 'Gestion efficace des voyages d\'entreprise.',
      cruiseTitle: 'Croisières',
      cruiseDesc: 'Expériences de croisière inoubliables.',
      whyChooseTitle: 'Pourquoi voyager avec SRE GLOBAL?',
      expertTitle: 'Planification experte',
      expertDesc: 'Consultants en voyage expérimentés.',
      dealsTitle: 'Meilleures offres',
      dealsDesc: 'Prix compétitifs.',
      supportTitle: 'Support 24/7',
      supportDesc: 'Assistance 24h/24.',
      personalizedTitle: 'Service personnalisé',
      personalizedDesc: 'Chaque voyage est personnalisé.',
      startTitle: 'Commencez votre voyage aujourd\'hui',
      startDesc: 'Prêt à explorer le monde?',
      planTrip: 'Planifier votre voyage'
    },
    // Contact Page
    contact: {
      heroTitle: 'Contactez-nous',
      heroDesc: 'Nous sommes là pour vous aider.',
      getInTouch: 'Prendre contact',
      getInTouchDesc: 'Vous avez des questions sur nos services?',
      officeTitle: 'Nos bureaux',
      officeAddress: 'SRE GLOBAL, Mythenquai, Zurich, Suisse',
      emailTitle: 'Envoyez-nous un e-mail',
      emailDesc: 'Pour les demandes générales et le support',
      businessTitle: 'Demandes commerciales',
      businessDesc: 'Pour les partenariats et les opportunités commerciales',
      formTitle: 'Envoyez-nous un message',
      nameLabel: 'Nom complet',
      namePlaceholder: 'Votre nom',
      emailLabel: 'Adresse e-mail',
      emailPlaceholder: 'votre@email.fr',
      subjectLabel: 'Sujet',
      subjectPlaceholder: 'Comment pouvons-nous vous aider?',
      messageLabel: 'Message',
      messagePlaceholder: 'Dites-nous en plus...',
      sendMessage: 'Envoyer le message',
      successTitle: 'Message envoyé!',
      successDesc: 'Nous vous répondrons dans les 24 heures.'
    },
    // About Page
    about: {
      heroTitle: 'À propos de SRE GLOBAL',
      heroDesc: 'Une société de services financiers basée en Suisse, engagée à fournir des solutions d\'investissement innovantes, sécurisées et axées sur le client à l\'échelle mondiale.',
      aboutTitle: 'À propos de nous',
      aboutPara1: 'SRE GLOBAL est une société de services financiers basée en Suisse, engagée à fournir des solutions d\'investissement innovantes, sécurisées et axées sur le client à l\'échelle mondiale. Opérant à l\'intersection des marchés de capitaux internationaux et des technologies financières avancées, nous fournissons des services sur mesure conçus pour répondre aux besoins évolutifs des investisseurs individuels et institutionnels.',
      aboutPara2: 'En tant qu\'entreprise soutenue par la force et l\'héritage de son groupe parent, SWISS RE, SRE GLOBAL bénéficie d\'une solide base d\'expertise financière, d\'excellence en gestion des risques et de connaissance approfondie des marchés mondiaux. Ce positionnement stratégique nous permet d\'offrir des services de haute qualité fondés sur la confiance, la transparence et la création de valeur à long terme.',
      aboutPara3: 'Nos opérations sont alignées sur des normes réglementaires reconnues internationalement. À travers notre structure de groupe, nous maintenons la conformité avec les principales autorités financières, notamment la Financial Conduct Authority (FCA) du Royaume-Uni. En tant que société de courtage autorisée (Yetkili Aracı Kurum), ce cadre réglementaire multi-juridictionnel garantit que nos clients reçoivent des services conformes aux plus hauts niveaux de gouvernance, de sécurité et d\'intégrité opérationnelle.',
      aboutPara4: 'Chez SRE GLOBAL, nous sommes spécialisés dans un large éventail de services financiers, notamment la gestion de portefeuille, le conseil en investissement, les solutions de marchés de capitaux et les stratégies de gestion des risques. Notre mission est de donner à nos clients les outils, les perspectives et les opportunités dont ils ont besoin pour atteindre un succès financier durable dans un marché mondial de plus en plus complexe.',
      aboutPara5: 'Animé par l\'innovation et guidé par l\'expertise, SRE GLOBAL continue de bâtir des partenariats solides et de fournir l\'excellence dans tous les aspects des services financiers.',
      ourStoryTitle: 'Notre histoire',
      ourStoryDesc: 'SRE GLOBAL est devenu une marque mondiale de confiance.',
      missionTitle: 'Notre mission',
      missionDesc: 'Donner à nos clients les outils, les perspectives et les opportunités dont ils ont besoin pour atteindre un succès financier durable dans un marché mondial de plus en plus complexe.',
      visionTitle: 'Notre vision',
      visionDesc: 'Devenir le fournisseur le plus fiable et le plus innovant de services financiers, d\'assurance et de tourisme intégrés à l\'échelle mondiale.',
      valuesTitle: 'Nos valeurs',
      integrityTitle: 'Intégrité',
      integrityDesc: 'Nous travaillons avec honnêteté, transparence et pratiques éthiques dans tout ce que nous faisons.',
      excellenceTitle: 'Excellence',
      excellenceDesc: 'Nous visons l\'excellence dans la prestation de services et améliorons continuellement nos offres.',
      innovationTitle: 'Innovation',
      innovationDesc: 'Nous adoptons la technologie et l\'innovation pour fournir des solutions de pointe.',
      trustTitle: 'Confiance',
      trustDesc: 'Nous construisons des relations durables basées sur la confiance, la fiabilité et la satisfaction client.',
      globalTitle: 'Présence mondiale',
      globalDesc: 'Avec des bureaux et des partenaires dans le monde entier, SRE GLOBAL sert des clients sur tous les continents, offrant une expertise locale avec des standards mondiaux.'
    },
    // Client Tools Page
    clientTools: {
      heroTitle: 'Outils et services clients',
      heroDesc: 'Accédez à notre suite complète d\'outils numériques.',
      toolsTitle: 'Outils numériques',
      toolsDesc: 'Découvrez nos outils numériques de pointe.',
      platformTitle: 'Accès à la plateforme de trading',
      platformDesc: 'Accès aux plateformes de trading avancées.',
      analyticsTitle: 'Analyse de marché',
      analyticsDesc: 'Analyse de marché approfondie.',
      portfolioTitle: 'Gestionnaire de portefeuille',
      portfolioDesc: 'Gérez vos investissements.',
      trainingTitle: 'Formation & éducation',
      trainingDesc: 'Programmes de formation complets.',
      webinarsTitle: 'Webinaires en direct',
      webinarsDesc: 'Webinaires animés par des experts.',
      coursesTitle: 'Cours en ligne',
      coursesDesc: 'Cours à votre rythme.',
      supportTitle: 'Services de support',
      accountTitle: 'Gestion de compte',
      accountDesc: 'Gestionnaires de compte dédiés.',
      techTitle: 'Support technique',
      techDesc: 'Support technique 24/7.',
      accessTitle: 'Accédez à vos outils',
      accessDesc: 'Connectez-vous au portail client.',
      login: 'Connexion client'
    },
    // Forms Page
    forms: {
      heroTitle: 'Demander des informations',
      heroDesc: 'Remplissez le formulaire.',
      partnerTitle: 'Devenir partenaire',
      partnerDesc: 'Intéressé par un partenariat?',
      demoTitle: 'Demander une démo',
      demoDesc: 'Voyez notre plateforme en action.',
      quoteTitle: 'Obtenir un devis d\'assurance',
      quoteDesc: 'Devis d\'assurance gratuit.',
      tripTitle: 'Planifier un voyage',
      tripDesc: 'Parlez-nous de votre destination de rêve.',
      generalTitle: 'Demande générale',
      generalDesc: 'Vous avez une question?',
      nameLabel: 'Nom complet',
      namePlaceholder: 'Votre nom',
      emailLabel: 'E-mail',
      emailPlaceholder: 'votre@email.fr',
      phoneLabel: 'Téléphone (optionnel)',
      phonePlaceholder: '+33',
      companyLabel: 'Nom de l\'entreprise',
      companyPlaceholder: 'Votre entreprise',
      serviceLabel: 'Intérêt pour le service',
      messageLabel: 'Message',
      messagePlaceholder: 'Dites-nous en plus...',
      submit: 'Soumettre la demande',
      successTitle: 'Demande soumise!',
      successDesc: 'Nous vous contacterons dans les 24 heures.'
    },
    // Mutual Funds Page
    mutualFunds: {
      heroTitle: 'Fonds communs de placement',
      heroDesc: 'Accès à plus de 18 000 fonds.',
      accessFunds: 'Accéder aux fonds',
      introTitle: 'Gestion de fonds professionnelle',
      introDesc: 'SRE GLOBAL offre un accès à une vaste sélection de fonds communs de placement.',
      whyTitle: 'Pourquoi investir dans des fonds communs?',
      diversificationTitle: 'Diversification',
      diversificationDesc: 'Répartissez vos investissements.',
      managementTitle: 'Gestion professionnelle',
      managementDesc: 'Gestionnaires de fonds expérimentés.',
      accessibilityTitle: 'Accessibilité',
      accessibilityDesc: 'Commencez avec de petits montants.',
      liquidityTitle: 'Liquidité',
      liquidityDesc: 'Achetez et vendez facilement.',
      categoriesTitle: 'Catégories de fonds',
      equityTitle: 'Fonds d\'actions',
      equityDesc: 'Investir dans des actions.',
      bondTitle: 'Fonds obligataires',
      bondDesc: 'Investissements à revenu fixe.',
      balancedTitle: 'Fonds équilibrés',
      balancedDesc: 'Mélange d\'actions et d\'obligations.',
      indexTitle: 'Fonds indiciels',
      indexDesc: 'Suivre les indices de marché.',
      getStartedTitle: 'Investir aujourd\'hui',
      getStartedDesc: 'Commencez à construire votre portefeuille.',
      exploreFunds: 'Explorer les fonds'
    },
    // Legal Pages
    legal: {
      privacyTitle: 'Politique de confidentialité',
      privacyEffective: 'Date d\'entrée en vigueur: 1er janvier 2026',
      privacyIntro: 'SRE GLOBAL ("nous", "notre" ou "nos") s\'engage à protéger votre vie privée. Cette Politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous visitez notre site Web ou utilisez nos services.',
      termsTitle: 'Conditions générales',
      termsEffective: 'Date d\'entrée en vigueur: 1er janvier 2026',
      termsIntro: 'Ces Conditions générales ("Conditions") régissent votre utilisation du site Web et des services SRE GLOBAL. En accédant ou en utilisant nos services, vous acceptez d\'être lié par ces Conditions.',
      cookieTitle: 'Politique des cookies',
      cookieEffective: 'Date d\'entrée en vigueur: 1er janvier 2026',
      cookieIntro: 'Cette Politique des cookies explique comment SRE GLOBAL utilise les cookies et les technologies similaires pour vous reconnaître lorsque vous visitez notre site Web.',
      section1Title: '1. Informations que nous collectons',
      section2Title: '2. Comment nous utilisons vos informations',
      section3Title: '3. Sécurité des données',
      section4Title: '4. Vos droits',
      section5Title: '5. Contactez-nous',
      acceptanceTitle: '1. Acceptation des conditions',
      servicesTitle: '2. Nos services',
      userTitle: '3. Responsabilités de l\'utilisateur',
      intellectualTitle: '4. Propriété intellectuelle',
      limitationTitle: '5. Limitation de responsabilité',
      whatAreCookiesTitle: '1. Que sont les cookies?',
      howWeUseTitle: '2. Comment nous utilisons les cookies',
      yourChoicesTitle: '3. Vos choix de cookies',
      updateTitle: '4. Mises à jour de cette politique',
      contactTitle: '5. Informations de contact'
    },
    // SEO Keywords
    keywords: 'SRE GLOBAL, Yetkili Aracı Kurum, SRE GLOBAL PLATEFORME DE TRADING, SRE GLOBAL assurance, SRE GLOBAL Tourisme'
  }
};

